<!-- 
  添加新tab-pane步骤 （示例：test）
  1.创建template模板 （导出按钮居右，其余按钮居左）handleClick(页头点击触发)
  2.字段添加 inputTestData(查询表单)  testTable (表格数据) totalTest (分页器总条数) 
  3.函数添加 testDetails（查询/重置）handleCurrentTest（切换页码）handleSizeTest（切换条数/页）
  4.表格操作 exportTheData(导出不需要短信验证) export_get(导出短信验证弹窗) batchMark(批量标记) markIss(标记)
  5.图表数据 在mounted里修改dataSummary
 -->
<template>
  <div class="acitvityAll">
    <div class="headReturn">
      <!-- <span @click="toSetting">
        <i class="el-icon-arrow-left"></i>
        返回列表
      </span>
      <span style="margin: 0 20px">|</span>
      <span class="name">{{ rowData.activityName }}</span> -->
      <div class="backBox">
        <img class="pointer" @click="toSetting()" src="@/assets/thdImg/pages/back.svg" alt="" />
        <span class="backBox_name">数据分析</span>
      </div>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="formSty">
      <el-tab-pane label="活动统计" name="first">
        <div class="section-right-content-box">
          <div style="margin: 20px 0px 20px 0px">
            <el-form label-width="10px">
              <el-form-item>
                <span style="margin-right: 20px">统计时间 :</span>
                <el-radio v-model="queryForm.evaluateTime" @change="timeChange" v-for="item in options.evaluateTimeOpt"
                  :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                <div class="my_select_time">
                  <el-date-picker prefix-icon="no_icon" v-model="postForm.startDate" type="date" :placeholder="'选择日期时间'"
                    size="small" :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" style="width: 120px; font-size: 12px" class="time1"
                    :clearable="false"></el-date-picker>
                  <div class="time_to_text" :class="{
                    to_text_disabled: queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
                  }">
                    至
                  </div>
                  <el-date-picker prefix-icon="no_icon" v-model="postForm.endDate" type="date" :placeholder="'选择日期时间'"
                    size="small" :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" style="width: 145px; font-size: 12px" class="time2"
                    :clearable="true"></el-date-picker>
                  <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
                  <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
                </div>
                <el-button class="b1" style="margin-left: 20px" @click="querySeach()"><span style="marginleft: 4px">
                    查询</span></el-button>
                <el-button class="b2" style="margin-left: 20px" @click="queryOne()"><span
                    style="marginleft: 4px">重置</span></el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">数据总览</span>
          </div>
          <div v-loading="loading">
            <div class="overview1" style="float: left" v-for="(item, index) in dataSummary" :key="index + item.value">
              <div>
                <span class="fontClass">{{ item.name }}</span>
                <el-popover v-if="item.tips" placement="top-start" width="200" offset="100" trigger="hover"
                  :content="item.tipsName">
                  <span style="float: right; margin-top: -10px" slot="reference">
                    <p class="question_icon">?</p>
                  </span>
                </el-popover>
              </div>
              <div class="num">{{ tableTotal[item.value] }}</div>
            </div>
          </div>
          <div style="clear: left" ref="payRemindChart" class="chart" v-loading="loading"></div>
          <el-table :data="activityTable" :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }" style="width: 100%; margin: 40px auto">
            <el-table-column prop="statsDate" label="参与时间"> </el-table-column>
            <el-table-column label="活动参与统计" width="500" v-if="fitersChooseIF([28, 30], '!=')">
              <template slot-scope="scope">
                <span>参与人数:{{ scope.row.joinNumber }} </span>
                <span>参与人次:{{ scope.row.joinTimes }} </span>
                <span>新增人数:{{ scope.row.incrFollowNumber }} </span>
              </template>
            </el-table-column>
            <el-table-column label="活动参与统计" width="500" v-else-if="fitersChooseIF([30, 33])">
              <template slot-scope="scope">
                <span>点击人数:{{ scope.row.uv }} </span>
                <span>参与人数:{{ scope.row.joinNumber }} </span>
                <span>新增人数:{{ scope.row.incrFollowNumber }} </span>
              </template>
            </el-table-column>
            <el-table-column label="活动参与统计" width="500" v-else>
              <template slot-scope="scope">
                <span>点击人数:{{ scope.row.uv }} </span>
                <span>点击次数:{{ scope.row.pv }} </span>
                <span>人均点击次数:{{ scope.row.perClickNumber }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="prizeNum" label="奖品统计" v-if="fitersChooseIF([28, 30], '!=')">
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.aqy != null"> 爱奇艺会员:{{ scope.row.aqy }}个 </span>
                <span v-if="scope.row.beans != null"> 京豆:{{ scope.row.beans }}个 </span> -->
                <span v-if="scope.row.coupon != null"> 优惠券:{{ scope.row.coupon }}张 </span>
                <span v-if="scope.row.eCard != null"> E卡:{{ scope.row.eCard }}张 </span>
                <span v-if="scope.row.goods != null"> 实物:{{ scope.row.goods }}件 </span>
                <!-- <span v-if="scope.row.plus != null"> PLUS会员:{{ scope.row.plus }}个 </span> -->
                <span v-if="scope.row.redPacket != null"> 红包:{{ scope.row.redPacket }}元 </span>
                <span v-if="scope.row.scores != null"> 积分:{{ scope.row.scores }}积分 </span>
                <span v-if="scope.row.specialItems != null"> 实物（专属下单）:{{ scope.row.specialItems }}件 </span>
                <!-- <span>参与人次:{{ scope.row.joinTimes }} </span>
                <span>新增人数:{{ scope.row.incrFollowNumber }} </span> -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeChange" background
            @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
            :current-page="formList.current"></el-pagination>
        </div>
      </el-tab-pane>
      <!-- 参与记录 -->
      <el-tab-pane label="参与记录" name="eleven" v-if="fitersChooseIF([23, 24, 26, 27])">
        <input-form v-if="fitersChooseIF([23, 24])" :inputData="inputParticipat" @toParentVal="searchParticipationForm"
          :btnPosition1="true" style="margin: 20px 0"></input-form>
        <input-form v-if="fitersChooseIF([26])" :inputData="inputAwardOrd26" @toParentVal="searchParticipationForm"
          :btnPosition1="true" style="margin: 20px 0"></input-form>
        <input-form v-if="fitersChooseIF([27])" :inputData="inputAwardOrd" @toParentVal="searchParticipationForm"
          :btnPosition1="true" style="margin: 20px 0"></input-form>
        <el-button v-if="fitersChooseIF([26, 27])" style="float: right; margin-bottom: 20px" class="expectBox"
          @click="exportTheData" v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="ParticipatTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
          <el-table-column prop="joinTime" label="参与时间"> </el-table-column>
          <el-table-column v-if="fitersChooseIF([23])" prop="score" label="得分">
            <template slot-scope="scope">
              <span> {{ scope.row.score || scope.row.score == 0 ? scope.row.score : "--" }} </span>
            </template>
          </el-table-column>
          <el-table-column v-if="fitersChooseIF([26])" prop="score" label="抽奖码">
            <template slot-scope="scope">
              <span> {{ scope.row.lotteryCode }} </span>
            </template>
          </el-table-column>
          <el-table-column v-if="fitersChooseIF([26])" prop="score" label="是否填写地址">
            <template slot-scope="scope">
              <span> {{ scope.row.isWriteAddress == 1 ? '已填写' : '未填写' }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="报名商品" v-if="fitersChooseIF([27])"> </el-table-column>
          <el-table-column label="中奖状态" v-if="fitersChooseIF([26, 27])">
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <span v-if="scope.row.status == -1">待领取</span>
                <span v-if="scope.row.status == 0">-</span>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>
                  {{ rowData.activityType == 26 || rowData.activityType == 16 || rowData.activityType == 17 ||
                    rowData.activityType == 18 ? "待发放" : "已中奖" }}
                </span>
                <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
                <span v-if="scope.row.status == 5"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 6"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 7"><i class="y2"></i>未发放</span>
                <span v-if="scope.row.status == 8"><i class="y2"></i>待领取</span>
                <span v-if="scope.row.status == 9"><i class="y2"></i>已失效</span>
                <el-tooltip effect="dark" :content="scope.row.failReason" placement="top-start">
                  <img v-if="scope.row.status == 4" src="../../assets/images/ask.png" alt="" />
                </el-tooltip>
              </template>
              <template v-else>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>已中奖</span>
                <span v-if="scope.row.status == 8"><i class="y2"></i>待领取</span>
                <span v-if="scope.row.status == 9"><i class="y2"></i>已失效</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="fitersChooseIF([26, 27])">
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType == 10">
                <el-button type="text" v-if="scope.row.freeLotteryOpenType == 0 && scope.row.status == 0"
                  @click="markIss(scope.row, 'win')">标记中奖</el-button>
                <span v-else>-</span>
              </template>
              <template v-else>
                <el-button type="text" v-if="scope.row.freeLotteryOpenType == 0 && scope.row.status == 0"
                  @click="markIss(scope.row, 'win')">标记中奖</el-button>
                <el-button type="text" v-if="scope.row.status == 2 || scope.row.status == 4 || scope.row.status == 7"
                  @click="markIss(scope.row)">标记发放</el-button>
                <el-button type="text" v-if="scope.row.status == 5 || scope.row.status == 6"
                  @click="markIss(scope.row)">取消发放</el-button>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="isPass" label="是否通关" v-if="!fitersChooseIF([26, 27])">
            <template slot-scope="scope">
              <span> {{ scope.row.isPass == 1 ? "是" : scope.row.isPass == 0 ? "否" : "--" }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="isDraw" label="是否抽奖" v-if="!fitersChooseIF([26, 27])">
            <template slot-scope="scope">
              <span> {{ scope.row.isDraw == 1 ? "是" : scope.row.isDraw == 0 ? "否" : "--" }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="isWin" label="是否中奖" v-if="!fitersChooseIF([26, 27])">
            <template slot-scope="scope">
              <span> {{ scope.row.isWin == 1 ? "是" : scope.row.isWin == 0 ? "否" : "--" }} </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeParticipat" background
          @current-change="handleCurrentParticipat" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalParticipat"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 满额有礼-参与记录 -->
      <el-tab-pane label="参与记录" name="twentySix" v-if="fitersChooseIF([34, 35])">
        <input-form v-if="fitersChooseIF([34, 35])" :inputData="fitersChooseIF([34]) ? inputfulfil : inputOrder"
          @toParentVal="searchParticipationForm3" :btnPosition1="true" style="margin: 20px 0"></input-form>
        <el-button v-if="fitersChooseIF([34, 35])" style="float: right; margin-bottom: 20px" class="expectBox"
          @click="exportTheData(19)" v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="ParticipatTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称"> </el-table-column>
          <el-table-column :prop="fitersChooseIF([35]) ? 'joinTime' : 'createTime'" label="参与时间"> </el-table-column>
          <el-table-column prop="rank" label="活动排名" v-if="fitersChooseIF([35])">
            <template slot-scope="scope">
              <span>{{ scope.row.rank ? scope.row.rank : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="taskIndex" label="所属阶梯" v-if="fitersChooseIF([35])">
            <template slot-scope="scope">
              <span>{{ scope.row.taskIndex ? scope.row.taskIndex : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="isReceiveStr" label="是否领取奖品" v-if="fitersChooseIF([35])"></el-table-column>
          <el-table-column :prop="fitersChooseIF([35]) ? 'orderNum' : 'orderCount'" label="订单总数"> </el-table-column>
          <el-table-column :prop="fitersChooseIF([35]) ? 'orderPayAmt' : 'paymentTotal'" label="总实付金额（已付款）">
          </el-table-column>
          <el-table-column :prop="fitersChooseIF([35]) ? 'orderFinshAmt' : 'confirmReceiptTotal'" label="总实付金额（已收货）">
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeParticipat3" background
          @current-change="handleCurrentParticipat3" :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="fitersChooseIF([34]) ? formList.size : orderList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalParticipat"
          :current-page="fitersChooseIF([34]) ? formList.current : orderList.current"></el-pagination>
      </el-tab-pane>
      <!-- 调查问卷--参与记录 -->
      <el-tab-pane label="参与记录" name="twentyOne" v-if="fitersChooseIF([31])">
        <input-form v-if="fitersChooseIF([31])" :inputData="inputAwardOrd" @toParentVal="searchParticipationForm2"
          :btnPosition1="true" style="margin: 20px 0"></input-form>
        <el-button v-if="fitersChooseIF([31])" style="float: right; margin-bottom: 20px" class="expectBox"
          @click="exportTheData" v-preventReClick>导出</el-button>
        <el-button v-if="fitersChooseIF([31])" style="float: right; margin: 0 20px 20px 0;" class="questionBox"
          @click="qusetionData">问卷统计</el-button>
        <el-table v-loading="loading" :data="ParticipatTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
          <el-table-column prop="joinTime" label="参与时间"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称" v-if="fitersChooseIF([31])"> </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称" v-if="fitersChooseIF([31])"> </el-table-column>
          <el-table-column label="奖品类型" v-if="fitersChooseIF([31])">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1">优惠券</span>
              <span v-if="scope.row.prizeType == 2">京豆</span>
              <span v-if="scope.row.prizeType == 3">实物</span>
              <span v-if="scope.row.prizeType == 4">店铺积分</span>
              <span v-if="scope.row.prizeType == 5">京豆E卡</span>
              <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
              <span v-if="scope.row.prizeType == 7">京豆PLUS会员</span>
              <span v-if="scope.row.prizeType == 8">现金红包</span>
              <span v-if="scope.row.prizeType == 9">谢谢参与</span>
              <span v-if="scope.row.prizeType == 10">实物（专属下单）</span>
            </template>
          </el-table-column>
          <el-table-column label="中奖状态" v-if="fitersChooseIF([31])">
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <span v-if="scope.row.status == -1">待领取</span>
                <span v-if="scope.row.status == 0">-</span>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>
                  {{ rowData.activityType == 26 || rowData.activityType == 16 || rowData.activityType == 17 ||
                    rowData.activityType == 18 ? "待发放" : "已中奖" }}
                </span>
                <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
                <span v-if="scope.row.status == 5"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 6"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 7"><i class="y2"></i>未发放</span>
                <el-tooltip effect="dark" :content="scope.row.failReason" placement="top-start">
                  <img v-if="scope.row.status == 4" src="../../assets/images/ask.png" alt="" />
                </el-tooltip>
              </template>
              <template v-else>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>已中奖</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column v-if="fitersChooseIF([31])" prop="score" label="是否填写地址">
            <template slot-scope="scope">
              <span> {{ scope.row.isWriteAddress == 1 ? '已填写' : '未填写' }} </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="fitersChooseIF([31])">
            <template slot-scope="scope">
              <el-button type="text" @click="questionLook(scope.row.pin)">查看问卷</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeParticipat2" background
          @current-change="handleCurrentParticipat2" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalParticipat"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>

      <!-- 会员升级礼--参与记录 -->
      <el-tab-pane label="参与记录" name="twentyEight" v-if="fitersChooseIF([37])">
        <input-form :inputData="inputAwardOrd28" @toParentVal="searchParticipationForm28" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <div style="display: flex;justify-content: flex-end; margin-bottom: 20px">
          <el-button @click="exportTheData" v-preventReClick>导出</el-button>
        </div>
        <el-table v-loading="loading" :data="ParticipatTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%;">
          <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称"> </el-table-column>
          <el-table-column prop="createTime" label="参与时间"> </el-table-column>
          <el-table-column prop="memberInitialLevelName" label="初始会员等级"> </el-table-column>
          <el-table-column prop="latestJoinTime" label="最新访问活动时间"> </el-table-column>
          <el-table-column prop="memberLatestLevelName" label="最新会员等级"> </el-table-column>
          <el-table-column prop="isUpgrades" label="是否发生升级">
            <template slot-scope="scope">
              <span v-if="scope.row.isUpgrades == 0">否</span>
              <span v-if="scope.row.isUpgrades == 1">是</span>
            </template>
          </el-table-column>
          <el-table-column prop="upLevelNumber" label="升级级数"> </el-table-column>
          <el-table-column prop="isWin" label="是否领取奖品">
            <template slot-scope="scope">
              <span v-if="scope.row.isWin == 0">否</span>
              <span v-if="scope.row.isWin == 1">是</span>
            </template> </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeParticipat28" background
          @current-change="handleCurrentParticipat28" :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size" layout="total, sizes, prev, pager, next, jumper" :total="totalParticipat"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>

      <!-- 会员升级礼--领奖记录 -->
      <el-tab-pane label='领奖记录' name="twentyNine" v-if="fitersChooseIF([37])">
        <input-form :inputData="inputAward29" ref="export_fun" @toParentVal="searchAward29" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px;" class="expectBox" @click="exportTheData"
          v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="awardTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; ">
          <el-table-column prop="memberNick" label="用户昵称" width="180"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称" width="180"> </el-table-column>
          <el-table-column prop="memberLevelName" label="会员等级" width="180"> </el-table-column>
          <el-table-column prop="isFillAddress" label="奖品类型" width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1">优惠券</span>
              <span v-if="scope.row.prizeType == 2">京豆</span>
              <span v-if="scope.row.prizeType == 3">实物</span>
              <span v-if="scope.row.prizeType == 4">店铺积分</span>
              <span v-if="scope.row.prizeType == 5">京豆E卡</span>
              <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
              <span v-if="scope.row.prizeType == 7">京豆PLUS会员</span>
              <span v-if="scope.row.prizeType == 8">现金红包</span>
              <span v-if="scope.row.prizeType == 9">谢谢参与</span>
              <span v-if="scope.row.prizeType == 10">实物（专属下单）</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称" width="280"> </el-table-column>
          <el-table-column prop="joinTime" label="领奖时间" width="280"> </el-table-column>
          <el-table-column prop="grantTime" label="发放时间" width="280"> </el-table-column>
          <el-table-column prop="statusStr" label="中奖状态" width="280"> </el-table-column>
          <el-table-column label="操作" v-if="fitersChooseIF([16, 17, 18, 19, 27, 28, 37], '!=')" width="100">
            <template slot-scope="scope">
              <el-button type="text" v-if="(scope.row.status == 2 || scope.row.status == 7) && scope.row.recordId"
                @click="markIss(scope.row)" style="text-align:left;">标记发货</el-button>
              <el-button type="text" v-if="scope.row.status == 5" @click="markIss(scope.row)"
                style="text-align:left;">取消发货</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-else>
            <template slot-scope="scope">
              <el-button type="text" style="text-align:left;" v-if="scope.row.status == 4"
                @click="markIss(scope.row)">标记发放</el-button>
              <el-button type="text" style="text-align:left;" v-if="scope.row.status == 6"
                @click="markIss(scope.row)">取消发放</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeAward29" background
          @current-change="handleCurrentAward29" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalAward"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 会员升级礼--实物奖品名单 -->
      <el-tab-pane label="实物奖品名单" name="thirty" v-if="fitersChooseIF([37])">
        <input-form :inputData="inputData30" @toParentVal="search30" @export_get="export_get" ref="export_fun"
          :btnPosition="true" style="margin: 20px 0"></input-form>
        <div style="display: flex;justify-content: space-between; margin-bottom: 20px">
          <el-button @click="batchLock" v-preventReClick>批量发货</el-button>
          <el-button @click="export_fun" v-preventReClick>导出</el-button>
        </div>
        <el-table v-loading="loading" :data="inkindTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%;">
          <el-table-column prop="recordId" label="中奖ID" width="210"> </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="210"> </el-table-column>
          <el-table-column prop="memberNick" label="会员等级" width="210"> </el-table-column>
          <el-table-column prop="prizeTitle" label="奖品名称" width="210"> </el-table-column>
          <el-table-column prop="sendTime" label="中奖时间" width="300">
          </el-table-column>
          <el-table-column prop="receiverName" label="收件人" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName }}
                <div class="openHover" v-if="scope.row.receiverName && scope.row.receiverName.indexOf('*') != -1"
                  @click="handleDecrypt('receiverName', 'inkindTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverMobile" label="手机号码" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile }}
                <div class="openHover" v-if="scope.row.receiverMobile && scope.row.receiverMobile.indexOf('*') != -1"
                  @click="handleDecrypt('mobile', 'inkindTable', scope.row, scope.$index, 'phone')">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverAddress" label="地区" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress }}
                <div class="openHover" v-if="scope.row.receiverAddress && scope.row.receiverAddress.indexOf('*') != -1"
                  @click="handleDecrypt('receiverAddress', 'inkindTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="detailedAddress" label="详细地址" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.detailedAddress }}
                <div class="openHover" v-if="scope.row.detailedAddress && scope.row.detailedAddress.indexOf('*') != -1"
                  @click="handleDecrypt('detailedAddress', 'inkindTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="grantTime" label="发货时间" width="210"> </el-table-column>
          <el-table-column prop="statusStr" label="发货状态" width="210"> </el-table-column>
          <el-table-column prop="billCode" label="快递单号" width="210">
            <template slot-scope="scope">{{ scope.row.billCode || '-' }}</template>
          </el-table-column>
          <el-table-column label="操作" width="210">
            <template slot-scope="scope">
              <el-button class="enter-btn" type="text" @click="handleEnterCoutierNum(scope.row)"
                v-if="rowData.activityType == 31 || rowData.activityType == 35 || rowData.activityType == 37">发货</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin:25px" @size-change="handleSizeInkind30" background
          @current-change="handleCurrentInkind30" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalInkind"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>

      <!-- 积分兑换 -->
      <el-tab-pane label="兑换明细" name="thirtyThree" v-if="fitersChooseIF([33])">
        <input-form :inputData="pointExchageForm" @toParentVal="searchExchange" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData"
          v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="exchangeGoodsTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="joinTime" label="兑换时间"></el-table-column>
          <el-table-column prop="memberNick" label="买家昵称"></el-table-column>
          <el-table-column prop="prizeName" label="兑换商品"></el-table-column>
          <el-table-column label="发放状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == -1">待领取</span>
              <span v-if="scope.row.status == 0">-</span>
              <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
              <span v-if="scope.row.status == 2"><i class="y2"></i>
                {{ rowData.activityType == 26 || rowData.activityType == 16 || rowData.activityType == 17 ||
                  rowData.activityType == 18 ? "待发放" : "已中奖" }}
              </span>
              <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
              <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
              <span v-if="scope.row.status == 5"><i class="y4"></i>已发放</span>
              <span v-if="scope.row.status == 6"><i class="y4"></i>已发放</span>
              <span v-if="scope.row.status == 7"><i class="y2"></i>未发放</span>
              <el-tooltip effect="dark" :content="scope.row.failReason" placement="top-start">
                <img v-if="scope.row.status == 4" src="../../assets/images/ask.png" alt="" />
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <el-button type="text" v-if="scope.row.status == 2 || scope.row.status == 4 || scope.row.status == 7"
                  @click="markIss(scope.row)">标记发放</el-button>
                <el-button type="text" v-if="scope.row.status == 5 || scope.row.status == 6"
                  @click="markIss(scope.row)">取消发放</el-button>
              </template>
              <template v-else>-</template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleExchangeList" background
          @current-change="handleCurrentExchangeList" :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size" layout="total, sizes, prev, pager, next, jumper" :total="totalAward"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 入会打榜 -->
      <el-tab-pane label="打榜名单" name="twentyFive" v-if="fitersChooseIF([25])">
        <input-form :inputData="inputAwardJoin" @toParentVal="searchAwardOneJoin" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData"
          v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="joinTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="index" label="排名" width="210"> </el-table-column>
          <el-table-column prop="memberNick" label="买家昵称"> </el-table-column>
          <el-table-column prop="inviteNum" label="邀请人数" width="150">
            <template slot-scope="scope">
              <div class="inviteNum" style="text-align: left;" @click="winningDetails(scope.row)">{{ scope.row.inviteNum
              }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="availablePrize" label="可获得奖品"> </el-table-column>
          <el-table-column label="中奖状态">
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <span v-if="scope.row.status == -1">待领取</span>
                <span v-if="scope.row.status == 0">-</span>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>
                  {{ rowData.activityType == 26 || rowData.activityType == 16 || rowData.activityType == 17 ||
                    rowData.activityType == 18 ? "待发放" : "已中奖" }}
                </span>
                <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
                <span v-if="scope.row.status == 5"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 6"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 7"><i class="y2"></i>未发放</span>
                <el-tooltip effect="dark" :content="scope.row.failReason" placement="top-start">
                  <img v-if="scope.row.status == 4" src="../../assets/images/ask.png" alt="" />
                </el-tooltip>
              </template>
              <template v-else>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>已中奖</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <el-button type="text" v-if="scope.row.status == 2 || scope.row.status == 4 || scope.row.status == 7"
                  @click="markIss(scope.row)">标记发放</el-button>
                <el-button type="text" v-if="scope.row.status == 5 || scope.row.status == 6"
                  @click="markIss(scope.row)">取消发放</el-button>
              </template>
              <template v-else>-</template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeRank" background
          @current-change="handleCurrentRank" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalAward"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 签到纪录 -->
      <el-tab-pane label="签到记录" name="second" v-if="fitersChooseIF([1])">
        <input-form :inputData="inputData" @toParentVal="searchForm" :btnPosition="true"
          style="margin: 20px 0"></input-form>
        <el-table v-loading="loading" :data="signInTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="用户昵称" width="400"> </el-table-column>
          <el-table-column prop="signTime" label="签到时间" width="400"> </el-table-column>
          <el-table-column prop="cumulativeTimes" label="累计签到次数(含历史记录)" width="400"> </el-table-column>
          <el-table-column prop="sequenceTimes" label="连续签到次数(不含历史记录)"> </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeSignIn" background
          @current-change="handleCurrentSignIn" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalSignIn"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 预约记录 -->
      <el-tab-pane label="预约记录" name="fifteen" v-if="fitersChooseIF([30])">
        <!-- 头部表单查询 -->
        <input-form :inputData="inputDataThir3" @toParentVal="searchFormThir2" :btnPosition1="true"
          style="margin: 20px 0" ref="inputRef2"></input-form>

        <!-- 表格 -->
        <el-table v-loading="loading" :data="exchangeList" style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }">
          <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
          <el-table-column prop="joinTime" label="预约时间"></el-table-column>
          <el-table-column prop="isWin" label="中奖状态">
            <template slot-scope="scope">
              <span v-if="scope.row.isWin == 1">已中奖</span>
              <span v-if="scope.row.isWin == 0">未中奖</span>
              <span v-if="scope.row.isWin == 2">待开奖</span>
            </template>
          </el-table-column>

        </el-table>

        <!-- 表格分页 -->
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeExchange2" background
          @current-change="handleCurrentExchange2" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalMail"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 中奖纪录 -->
      <el-tab-pane :label="fitersRepurchase([16, 17, 18, 23, 24, 25], '领奖记录', '中奖记录')" name="third"
        v-if="fitersChooseIF([13, 14, 15, 21, 25, 26, 27, 28, 30, 31, 32, 33, 34, 35, 37], '!=')">
        <input-form :inputData="rowData.activityType == 1 ? inputAwardSpecial1 :
          rowData.activityType == 8 ? inputAwardSpecial8 :
            rowData.activityType == 19 ? inputAwardSpecial19 :
              rowData.activityType == 16 ? inputAwardSpecial1 :
                rowData.activityType == 17 ? inputAwardSpecial1 :
                  rowData.activityType == 18 ? inputAwardSpecial1 :
                    inputAward
          " @toParentVal="searchAwardOne" :btnPosition1="true" style="margin: 20px 0" ref="searchForm"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData"
          v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="awardTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="用户昵称" width="210"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称"
            v-if="rowData.activityType != 5 && rowData.activityType != 6">
          </el-table-column>
          <el-table-column label="邀请人数" v-if="rowData.activityType == 5 || rowData.activityType == 6">
            <template slot-scope="scope">
              <div class="inviteNum" @click="openInviteInfo(scope.row)">{{ scope.row.inviteNum }}</div>
            </template>
          </el-table-column>
          <el-table-column label="奖品类型" v-if="rowData.activityType != 5 && rowData.activityType != 6">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1">优惠券</span>
              <span v-if="scope.row.prizeType == 2">京豆</span>
              <span v-if="scope.row.prizeType == 3">实物</span>
              <span v-if="scope.row.prizeType == 4">店铺积分</span>
              <span v-if="scope.row.prizeType == 5">京豆E卡</span>
              <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
              <span v-if="scope.row.prizeType == 7">京豆PLUS会员</span>
              <span v-if="scope.row.prizeType == 8">现金红包</span>
              <span v-if="scope.row.prizeType == 9">谢谢参与</span>
              <span v-if="scope.row.prizeType == 10">实物（专属下单）</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称" width="210"> </el-table-column>
          <template v-if="fitersChooseIF([16, 17, 18, 19])">
            <el-table-column label="订单号" width="210">
              <template slot-scope="scope">
                <!-- 淘宝3.31 双订单显示处理 -->
                <div v-if="fitersChooseIF([16, 18])">
                  <div v-for="(item, index) in scope.row.unlockOrderVOS" :key="'order' + index">
                    <el-popover placement="bottom" width="100%" trigger="hover">
                      <div class="referencePopover">
                        <span>订单号：{{ item.tid }}</span>
                        <span>订单金额：{{ item.tradePayment }}元</span>
                        <span>订单状态：{{ item.tradeStatus }}</span>
                      </div>
                      <span class="referenceButton" slot="reference">{{ item.tid }}</span>
                    </el-popover>
                  </div>
                </div>
                <div v-else>
                  <el-popover placement="bottom" width="100%" trigger="hover">
                    <div class="referencePopover">
                      <span>订单号：{{ scope.row.unlockOrderId }}</span>
                      <span>订单金额：{{ scope.row.tradePayment }}元</span>
                      <span>订单状态：{{ scope.row.tradeStatus }}</span>
                    </div>
                    <span class="referenceButton" slot="reference">{{ scope.row.unlockOrderId }}</span>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="mobile" label="手机号" width="150" v-if="rowData.activityType == 5">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile }}
                <div class="openHover" v-if="scope.row.mobile && scope.row.mobile.indexOf('*') != -1"
                  @click="handleDecrypt('mobile', 'awardTable', scope.row, scope.$index, 'phone')">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="参与时间" width="300" v-if="rowData.activityType != 5 && rowData.activityType != 6">
            <template slot-scope="scope">
              <span>{{ scope.row.joinTime }} </span>
            </template>
          </el-table-column>
          <el-table-column label="发放状态" width="100">
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <span v-if="scope.row.status == -1">待领取</span>
                <span v-if="scope.row.status == 0">-</span>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>待发放
                  <!-- {{ rowData.activityType == 16 || rowData.activityType == 17 || rowData.activityType == 18 ? "待发放" :
                    "已中奖" }} -->
                </span>
                <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
                <span v-if="scope.row.status == 5"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 6"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 7"><i class="y2"></i>未发放</span>
                <span v-if="scope.row.status == 8"><i class="y2"></i>待领取</span>
                <span v-if="scope.row.status == 9"><i class="y3"></i>已失效</span>
                <el-tooltip effect="dark" :content="scope.row.failReason" placement="top-start"
                  v-if="scope.row.status == 4">
                  <img src="../../assets/images/ask.png" alt="" />
                </el-tooltip>
              </template>
              <template v-else>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>已中奖</span>
                <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="remarkTime"
            v-if="rowData.activityType == 1 || rowData.activityType == 8 || rowData.activityType == 19 || rowData.activityType == 16 || rowData.activityType == 17 || rowData.activityType == 18"
            width="300">
            <template slot="header" slot-scope="scope">
              <span style="margin-right: 4px;">备注时间</span>
              <el-tooltip class="item" effect="dark"
                content="针对实物奖品，开启“奖品信息备注到订单”功能后，备注时间为备注奖品信息到订单上的时间，未开启则备注时间、备注订单号为空" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.remarkTime ? scope.row.remarkTime : '-' }} </span>
            </template>
          </el-table-column>
          <el-table-column label="备注订单号" width="210" prop="remarkTid"
            v-if="rowData.activityType == 1 || rowData.activityType == 8 || rowData.activityType == 19 || rowData.activityType == 16 || rowData.activityType == 17 || rowData.activityType == 18">
            <template slot-scope="scope">
              <span>{{ scope.row.remarkTid ? scope.row.remarkTid : '-' }} </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="fitersChooseIF([1, 8, 16, 17, 18, 19], '!=')">
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <el-button type="text" v-if="scope.row.status == 4 || scope.row.status == 2"
                  @click="markIss(scope.row)">标记发放</el-button>
                <el-button type="text" v-if="scope.row.status == 5 || scope.row.status == 6"
                  @click="markIss(scope.row)">取消发放</el-button>
              </template>
              <template v-else>-</template>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-else width="150">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 1"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
              > -->
              <template v-if="scope.row.prizeType != 10">
                <el-button type="text" v-if="scope.row.status == 2 || scope.row.status == 4 || scope.row.status == 7"
                  @click="markIss(scope.row)">标记发放</el-button>
                <el-button type="text" v-if="scope.row.status == 5 || scope.row.status == 6"
                  @click="markIss(scope.row)">取消发放</el-button>
              </template>
              <template v-else>-</template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeAward" background
          @current-change="handleCurrentAward" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalAward"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 中奖纪录 -->

      <el-tab-pane label='中奖记录' name="third" v-if="fitersChooseIF([30])">
        <input-form :inputData="inputAwardTwo" ref="export_fun" @toParentVal="searchAwardOne" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-button style="float: left; margin-bottom: 20px;width: 120px;" type="primary" @click="batchMark(1)"
          v-preventReClick>批量标记发货</el-button>
        <el-button style="float: right; margin-bottom: 20px;" class="expectBox" @click="export_get"
          v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="awardTable"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="180"> </el-table-column>
          <el-table-column prop="prizeTitle" label="奖品名称" width="180"> </el-table-column>
          <el-table-column prop="isFillAddress" label="是否填写地址" width="180"></el-table-column>
          <el-table-column prop="joinTime" label="预约时间" width="280"> </el-table-column>
          <el-table-column prop="grantTime" label="发货时间" width="280"> </el-table-column>
          <el-table-column prop="grantTime" label="发货状态">
            <template slot-scope="scope">
              {{ scope.row.status == 5 ? "已发货" : "未发货" }}
            </template>
          </el-table-column>
          <el-table-column prop="receiverName" label="收件人">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName }}
                <div class="openHover" v-if="scope.row.receiverName && scope.row.receiverName.indexOf('*') != -1"
                  @click="handleDecrypt('receiverName', 'awardTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverMobile" label="收件人手机号" width="120">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile }}
                <div class="openHover" v-if="scope.row.receiverMobile && scope.row.receiverMobile.indexOf('*') != -1"
                  @click="handleDecrypt('receiverMobile', 'awardTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverAddress" label="收件人地址" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress }}
                <div class="openHover" v-if="scope.row.receiverAddress && scope.row.receiverAddress.indexOf('*') != -1"
                  @click="handleDecrypt('receiverAddress', 'awardTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="detailedAddress" label="收件人详细地址" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.detailedAddress }}
                <div class="openHover" v-if="scope.row.detailedAddress && scope.row.detailedAddress.indexOf('*') != -1"
                  @click="handleDecrypt('detailedAddress', 'awardTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="fitersChooseIF([16, 17, 18, 19, 27, 28], '!=')" width="100">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 1"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
              > -->
              <el-button type="text" v-if="(scope.row.status == 2 || scope.row.status == 7) && scope.row.recordId"
                @click="markIss(scope.row)" style="text-align:left;">标记发货</el-button>
              <el-button type="text" v-if="scope.row.status == 5" @click="markIss(scope.row)"
                style="text-align:left;">取消发货</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-else>
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 1"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</span
              > -->
              <el-button type="text" v-if="scope.row.status == 4" @click="markIss(scope.row)">标记发放</el-button>
              <el-button type="text" v-if="scope.row.status == 6" @click="markIss(scope.row)">取消发放</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeAward" background
          @current-change="handleCurrentAward" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalAward"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>

      <!-- 填写记录 -->
      <el-tab-pane label="填写记录" name="sixteen" v-if="fitersChooseIF([32])">
        <!-- 头部表单查询 -->
        <input-form :inputData="inputWriteData" @toParentVal="searchFormWrite" :btnPosition1="true"
          style="margin: 20px 0" :labelWidth="'140px'"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData(16)"
          v-preventReClick>导出</el-button>
        <!-- 表格 -->
        <el-table v-loading="loading" :data="writeTable" style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }">
          <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称"></el-table-column>
          <el-table-column prop="birthDay" label="生日时间">
            <template slot-scope="scope">
              <span>{{ scope.row.birthDay | spliceDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="填写时间"></el-table-column>
          <el-table-column prop="lastPrizeTime" label="最后领取奖品时间"></el-table-column>

        </el-table>

        <!-- 表格分页 -->
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeWrite" background
          @current-change="handleCurrentWrite" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalWrite"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 奖品领取记录 -->
      <el-tab-pane :label="fitersChooseIF([34, 35]) ? '领奖记录' : '奖品领取记录'" name="seventeen"
        v-if="fitersChooseIF([32, 34, 35])">
        <input-form :inputData="fitersChooseIF([34, 35]) ? inputAwardSpecial34 : inputPrizeReceive"
          @toParentVal="searchPrizeReceive" ref="export_fun" :btnPosition="true" style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData(17)"
          v-preventReClick v-if="rowData.activityType == 32">导出</el-button>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData(18)"
          v-preventReClick v-if="rowData.activityType == 34">导出</el-button>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData(20)"
          v-preventReClick v-if="rowData.activityType == 35">导出</el-button>
        <el-table v-loading="loading" :data="prizeReceiveTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 10px auto">
          <el-table-column prop="id" label="中奖ID" width="210" v-if="fitersChooseIF([34, 35])"> </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="210"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称" width="210" v-if="fitersChooseIF([34, 35])">
          </el-table-column>
          <el-table-column prop="stage" label="中奖所属阶梯" width="200" v-if="fitersChooseIF([34, 35])">
            <template slot-scope="scope">
              <span v-if="fitersChooseIF([35])">
                {{ scope.row.taskIndex ? scope.row.taskIndex : '-' }}
              </span>
              <span v-else-if="scope.row.stage">阶梯 {{ scope.row.stage }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="memberLevelName" label="会员等级" width="210" v-if="rowData.activityType == 32">
          </el-table-column>
          <el-table-column prop="birthDay" label="生日时间" width="200" v-if="rowData.activityType == 32">
            <template slot-scope="scope">
              <span>{{ scope.row.birthDay | spliceDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="奖品类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 0">未知</span>
              <span v-if="scope.row.prizeType == 1">优惠券</span>
              <span v-if="scope.row.prizeType == 3">实物</span>
              <span v-if="scope.row.prizeType == 4">店铺积分</span>
              <span v-if="scope.row.prizeType == 8">现金红包</span>
              <span v-if="scope.row.prizeType == 9">谢谢参与</span>
              <span v-if="scope.row.prizeType == 10">实物（专属下单）</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称" width="210" v-if="fitersChooseIF([34, 35])"> </el-table-column>
          <el-table-column label="中奖状态" prop="statusStr" v-if="fitersChooseIF([35])"></el-table-column>
          <el-table-column label="中奖状态" v-else>
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <span v-if="scope.row.status == -1">待领取</span>
                <span v-if="scope.row.status == 0">-</span>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>
                  {{ rowData.activityType == 16 || rowData.activityType == 17 || rowData.activityType == 18 ? "待发放" :
                    "已中奖" }}
                </span>
                <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
                <span v-if="scope.row.status == 5"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 6"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 9"><i class="y2"></i>已失效</span>
                <span v-if="scope.row.status == 8"><i class="y2"></i>待领取</span>
                <span v-if="scope.row.status == 7"><i class="y2"></i>未发放</span>
                <el-tooltip effect="dark" :content="scope.row.failReason" placement="top-start">
                  <img v-if="scope.row.status == 4" src="../../assets/images/ask.png" alt="" />
                </el-tooltip>
              </template>
              <template v-else>
                <span v-if="scope.row.status == 1"><i class="y1"></i>未中奖</span>
                <span v-if="scope.row.status == 2"><i class="y2"></i>已中奖</span>
                <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
                <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
                <span v-if="scope.row.status == 9"><i class="y3"></i>已失效</span>
                <span v-if="scope.row.status == 8"><i class="y2"></i>待领取</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime"
            :label="rowData.activityType == 32 ? '领取时间' : fitersChooseIF([35]) ? '领奖时间' : '领奖时间'" width="210">
          </el-table-column>
          <el-table-column prop="grantTime" label="发放时间" width="210" v-if="fitersChooseIF([34, 35])">
            <template slot-scope="scope">
              <span v-if="fitersChooseIF([35])">{{ scope.row.sendTime ? scope.row.sendTime : '-' }}</span>
              <span v-else>{{ scope.row.grantTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="remarkTime"
              v-if="fitersChooseIF([32, 34])"
              width="300"
            >
              <template slot="header" slot-scope="scope">
                <span style="margin-right: 4px">备注时间</span>
                <el-tooltip class="item" effect="dark" content="针对实物奖品，开启“奖品信息备注到订单”功能后，备注时间为备注奖品信息到订单上的时间，未开始则备注时间、备注订单号为空" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span
                  >{{ scope.row.remarkTime ? scope.row.remarkTime : "-" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="备注订单号"
              width="210"
              prop="remarkTid"
              v-if="fitersChooseIF([32, 34])"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.remarkTid ? scope.row.remarkTid : "-" }}
                </span>
              </template>
            </el-table-column>
          <el-table-column label="操作" v-if="fitersChooseIF([35])">
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <el-button class="marker-btn" type="text" v-if="scope.row.status == 0 || scope.row.status == 2"
                  @click="markIss2(scope.row)">标记发放</el-button>
                <el-button class="marker-btn" type="text" v-else-if="scope.row.isMarkSend == 1"
                  @click="markIss2(scope.row)">取消发放</el-button>
                <span v-else>-</span>
              </template>
              <template v-else>-</template>
            </template>
          </el-table-column>
          <el-table-column width="120" label="操作" v-else>
            <template slot-scope="scope">
              <template v-if="scope.row.prizeType != 10">
                <el-button class="marker-btn" type="text" v-if="scope.row.status == 4 || scope.row.status == 2"
                  @click="markIss(scope.row)">标记发放</el-button>
                <el-button class="marker-btn" type="text" v-if="scope.row.status == 5 || scope.row.status == 6"
                  @click="markIss(scope.row)">取消发放</el-button>
              </template>
              <template v-else>-</template>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="receiverCode" label="邮编"> </el-table-column> -->
        </el-table>
        <el-pagination style="text-align: right; margin:25px" @size-change="handleSizePrizeReceive" background
          @current-change="handleCurrentPrizeReceive" :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size" layout="total, sizes, prev, pager, next, jumper" :total="totalPrizeReceive"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 实物奖品 -->
      <el-tab-pane label="实物奖品名单" name="four"
        v-if="fitersChooseIF([1, 3, 5, 6, 8, 16, 17, 18, 19, 20, 22, 23, 24, 25, 26, 27,29,31,32,33,34,35])">
        <input-form :inputData="[1, 8, 16, 17, 18, 19, 26, 32].includes(rowData.activityType)? inputInkindSpecial : rowData.activityType==34 ||  rowData.activityType == 35? inputIfulfil: rowData.activityType==31 ? inputQuestion : inputInkind" @toParentVal="searchInkind" @export_get="export_get" ref="export_fun"
          :btnPosition="true" style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="export_fun"
          v-preventReClick>导出</el-button>
        <el-button style="float: right; margin-bottom: 20px;margin-right:10px" @click="batchLock"
          v-if="fitersChooseIF([31, 34, 35])" v-preventReClick>批量发货</el-button>
        <el-table v-loading="loading" :data="inkindTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 10px auto">
          <el-table-column prop="recordId" label="中奖ID" width="210" v-if="fitersChooseIF([34, 35])"> </el-table-column>
          <el-table-column prop="memberNick" label="用户昵称" width="210"> </el-table-column>
          <el-table-column :prop="fitersChooseIF([35])?'prizeName':'prizeTitle'" label="奖品名称" width="210"> </el-table-column>
          <el-table-column prop="sendTime" label="中奖时间" width="300" v-if="fitersChooseIF([31,34,35], '!=')"> </el-table-column>
          <el-table-column prop="remarkTime" v-if="[1, 8, 16, 17, 18, 19, 26, 32, 34].includes(rowData.activityType)" width="300">
            <template slot="header" slot-scope="scope">
              <span style="margin-right: 4px;">备注时间</span>
              <el-tooltip class="item" effect="dark" content="针对实物奖品，开启“奖品信息备注到订单”功能后，备注时间为备注奖品信息到订单上的时间，未开启则备注时间、备注订单号为空"
                placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.remarkTime ? scope.row.remarkTime : '-' }} </span>
            </template>
          </el-table-column>
          <el-table-column label="备注订单号" prop="remarkTid" v-if="[16, 17, 18, 19, 26, 32, 34].includes(rowData.activityType)"  width="210">
            <template slot-scope="scope">
              <span>{{ scope.row.remarkTid ? scope.row.remarkTid : '-' }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="receiverName" label="收件人" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverName }}
                <div class="openHover" v-if="scope.row.receiverName && scope.row.receiverName.indexOf('*') != -1"
                  @click="handleDecrypt('receiverName', 'inkindTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="收件人手机号" width="210" v-if="fitersChooseIF([35])">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile }}
                <div class="openHover" v-if="scope.row.mobile && scope.row.mobile.indexOf('*') != -1"
                  @click="handleDecrypt('mobile', 'inkindTable', scope.row, scope.$index, 'phone')">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverMobile" label="收件人手机号" width="210" v-else>
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverMobile }}
                <div class="openHover" v-if="scope.row.receiverMobile && scope.row.receiverMobile.indexOf('*') != -1"
                  @click="handleDecrypt('receiverMobile', 'inkindTable', scope.row, scope.$index, 'phone')">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverAddress" label="收件人地区" width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.receiverAddress }}
                <div class="openHover" v-if="scope.row.receiverAddress && scope.row.receiverAddress.indexOf('*') != -1"
                  @click="handleDecrypt('receiverAddress', 'inkindTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="detailedAddress" :label="fitersChooseIF([35]) ? '详细地址' : '收件人详细地址'" min-width="210">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.detailedAddress }}
                <div class="openHover" v-if="scope.row.detailedAddress && scope.row.detailedAddress.indexOf('*') != -1"
                  @click="handleDecrypt('detailedAddress', 'inkindTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sendTime" label="发放时间" width="210" v-if="fitersChooseIF([34, 35])"> </el-table-column>
          <el-table-column prop="sendTime" label="中奖时间" width="210" v-if="[31].includes(rowData.activityType)">
          </el-table-column>
          <el-table-column :prop="fitersChooseIF([35]) ? 'deliveryStatusStr' : 'statusStr'" label="发货状态" width="210"
            v-if="fitersChooseIF([31, 34, 35])"></el-table-column>
          <el-table-column prop="billCode" label="快递单号" width="210" v-if="fitersChooseIF([31, 33, 34, 35])">
            <template slot-scope="scope">{{ scope.row.billCode || '-' }}</template>
          </el-table-column>
          <el-table-column :prop="fitersChooseIF([35]) ? 'deliveryTime' : 'grantTime'" label="发货时间" width="210"
            v-if="fitersChooseIF([34, 35])">
            <template slot-scope="scope">
              <span v-if="fitersChooseIF([35])">
                {{ scope.row.deliveryTime || '-' }}
              </span>
              <span v-else>
                {{ scope.row.grantTime || '-' }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="receiverCode" label="邮编"> </el-table-column> -->
          <el-table-column label="操作" width="210" v-if="fitersChooseIF([31, 33, 34, 35])">
            <template slot-scope="scope">
              <el-button type="text" @click="handleEnterCoutierNum(scope.row)"
                v-if="[33, 34].includes(rowData.activityType)">录入快递单号</el-button>
              <el-button class="enter-btn" type="text" @click="handleEnterCoutierNum(scope.row)"
                v-if="rowData.activityType == 31 || rowData.activityType == 35">发货</el-button>
              <el-button class="enter-btn" type="text" @click="eduitAdress(scope.row)"
                v-if="rowData.activityType == 33 && permissionsList.includes('10290')">修改发货信息</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin:25px" @size-change="handleSizeInkind" background
          @current-change="handleCurrentInkind" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalInkind"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 资料明细 -->
      <el-tab-pane label="用户资料明细" name="five" v-if="fitersChooseIF([7])">
        <input-form :inputData="inputUserInfo" :defaultSelectArr="true" @toParentVal="searchUserInfo" :btnPosition="true"
          style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData"
          v-preventReClick>导出</el-button>
        <el-table :data="userInfoTable" :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }" style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="用户昵称" minWidth="150"> </el-table-column>
          <el-table-column prop="createTime" label="资料填写时间" minWidth="200"></el-table-column>
          <el-table-column prop="name" label="姓名" minWidth="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.name }}
                <div class="openHover" v-if="scope.row.name && scope.row.name.indexOf('*') != -1"
                  @click="handleDecrypt('name', 'userInfoTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" minWidth="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.mobile }}
                <div class="openHover" v-if="scope.row.mobile && scope.row.mobile.indexOf('*') != -1"
                  @click="handleDecrypt('mobile', 'userInfoTable', scope.row, scope.$index, 'phone')">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="birthDay" label="生日" minWidth="200">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.birthDay }}
                <div class="openHover" v-if="scope.row.birthDay && scope.row.birthDay.indexOf('*') != -1"
                  @click="handleDecrypt('birthDay', 'userInfoTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="qq" label="QQ" minWidth="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.qq }}
                <div class="openHover" v-if="scope.row.qq && scope.row.qq.indexOf('*') != -1"
                  @click="handleDecrypt('qq', 'userInfoTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="weChat" label="微信" minWidth="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.weChat }}
                <div class="openHover" v-if="scope.row.weChat && scope.row.weChat.indexOf('*') != -1"
                  @click="handleDecrypt('weChat', 'userInfoTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="性别" minWidth="150">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.sex == 0">未知</span>
              <span v-if="scope.row.sex == 1">男</span>
              <span v-if="scope.row.sex == 2">女</span> -->
              <div class="open">
                <span v-if="scope.row.sex && scope.row.sex.indexOf('*') != -1">{{ scope.row.sex }}</span>
                <span v-if="scope.row.sex == 0">未知</span>
                <span v-if="scope.row.sex == 1">男</span>
                <span v-if="scope.row.sex == 2">女</span>
                <div class="openHover" v-if="scope.row.sex && scope.row.sex.indexOf('*') != -1"
                  @click="handleDecrypt('sex', 'userInfoTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="job" label="职业" minWidth="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.job }}
                <div class="openHover" v-if="scope.row.job && scope.row.job.indexOf('*') != -1"
                  @click="handleDecrypt('job', 'userInfoTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="地区" minWidth="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.address }}
                <div class="openHover" v-if="scope.row.address && scope.row.address.indexOf('*') != -1"
                  @click="handleDecrypt('address', 'userInfoTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="detailedAddress" label="详细地址" minWidth="150">
            <template slot-scope="scope">
              <div class="open">
                {{ scope.row.detailedAddress }}
                <div class="openHover" v-if="scope.row.detailedAddress && scope.row.detailedAddress.indexOf('*') != -1"
                  @click="handleDecrypt('detailedAddress', 'userInfoTable', scope.row, scope.$index)">
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="扩展信息" minWidth="250">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.extendInfo | showextendInfo }}</span> -->
              <div style="display: flex;flex-wrap: wrap;">
                <div v-for="(item, index) in showextendInfo(scope.row.extendInfo)" class="info">
                  <div style="min-width: 60px;text-align: right;">{{ item.prop }}:</div>
                  <template v-if="item.isImg">
                    <div class="img-parent" v-for="child in item.keys">
                      <img class="info-img" :src="child" :preview-src-list="[child]"></img>
                      <div class="mask" @click="handlePictureCardPreview(child)">
                        <i class="el-icon-zoom-in"></i>
                      </div>
                    </div>
                  </template>
                  <span v-else style="margin-left: 4px;">{{ item.keys }}</span>
                  <span v-if="index != showextendInfo(scope.row.extendInfo).length - 1">；</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeUserInfo" background
          @current-change="handleCurrentUserInfo" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalUserInfo"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 发放记录 -->
      <el-tab-pane label="发放记录" name="six" v-if="fitersChooseIF([13, 14, 15])">
        <input-form :inputData="inputAwardOne" @toParentVal="searchAward" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData"
          v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="distributionTable"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称"> </el-table-column>
          <template v-if="rowData.activityType == 15">
            <el-table-column prop="sceneType" label="场景">
              <template slot-scope="scope">
                <span v-if="scope.row.sceneType == 1">未关注店铺用户</span>
                <span v-if="scope.row.sceneType == 2">店铺新客</span>
                <span v-if="scope.row.sceneType == 3">plus会员</span>
                <span v-if="scope.row.sceneType == 4">关注店铺用户</span>
                <span v-if="scope.row.sceneType == 5">店铺会员</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="奖品类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1">优惠券</span>
              <span v-if="scope.row.prizeType == 2">京豆</span>
              <span v-if="scope.row.prizeType == 4">店铺积分</span>
            </template>
          </el-table-column>
          <el-table-column prop="prizeName" label="奖品名称"> </el-table-column>
          <el-table-column label="发放状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">未知</span>
              <span v-if="scope.row.status == 3"><i class="y4"></i>已发放</span>
              <span v-if="scope.row.status == 4"><i class="y3"></i>发放失败</span>
              <el-tooltip effect="dark" :content="scope.row.failReason" placement="top-start">
                <img v-if="scope.row.status == 4" src="../../assets/images/ask.png" alt="" />
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="发放时间">
            <template slot-scope="scope">
              <span>{{ scope.row.joinTime }} </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeAwardOne" background
          @current-change="handleCurrentAwardOne" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="this.totalDistribution"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 抽奖机会赠送记录 -->
      <el-tab-pane label="抽奖机会赠送记录" name="seven" v-if="fitersChooseIF([20])">
        <input-form :inputData="inputComment" @toParentVal="searchComment" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-table v-loading="loading" :data="CommentList"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="nickName" label="用户昵称"> </el-table-column>
          <el-table-column prop="creationTime" label="评价时间"> </el-table-column>
          <el-table-column prop="skuId" label="SKUID"></el-table-column>
          <el-table-column prop="orderId" label="订单号"> </el-table-column>
          <el-table-column label="过滤状态">
            <template slot-scope="scope">
              <span v-if="scope.row.filterType == 0">未通过</span>
              <span v-if="scope.row.filterType == 1">通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="filterRemark" label="备注"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="commentDetails(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeComment" background
          @current-change="handleCurrentComment" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalComment"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 拼券明细 -->
      <el-tab-pane label="拼券明细" name="eight" v-if="fitersChooseIF([21])">
        <input-form :inputData="inputCoupon" @toParentVal="searchCoupon" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-table v-loading="loading" :data="couponDetailsList"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="name" label="用户昵称"> </el-table-column>
          <el-table-column prop="grantTime" label="领取时间"> </el-table-column>
          <!-- <el-table-column prop="activityNames" label="奖励类型"></el-table-column> -->
          <el-table-column prop="prizeName" label="奖励信息"> </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeCoupond" background
          @current-change="handleCurrentCoupond" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalCoupon"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 优惠券统计 -->
      <el-tab-pane label="优惠券统计" name="nine" v-if="fitersChooseIF([21])">
        <input-form :inputData="inputSplitCoupon" @toParentVal="searchSplit" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-table v-loading="loading" :data="CouponStatisticsList"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          row-key="id" style="width: 100%; margin: 40px auto" :tree-props="{ children: 'data' }">
          <el-table-column prop="name" label="日期"> </el-table-column>
          <el-table-column prop="grantNum" label="发放量"> </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeCouponStatistics" background
          @current-change="handleCurrentCouponStatistics" :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formList.size" layout="total, sizes, prev, pager, next, jumper" :total="totalCouponstatistics"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 团队详情 -->
      <el-tab-pane label="团队详情" name="ten" v-if="fitersChooseIF([21])">
        <input-form :inputData="inputGroupCoupon" @toParentVal="searchGroup" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-table v-loading="loading" :data="TeamDetailsList"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="leaderName" label="团长"> </el-table-column>
          <el-table-column prop="title" label="优惠券"> </el-table-column>
          <el-table-column prop="groupTime" label="组团时间"> </el-table-column>
          <el-table-column prop="status" label="组团状况">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">未知</span>
              <span v-if="scope.row.status === 1">组团中</span>
              <span v-if="scope.row.status === 2">组团成功</span>
            </template>
          </el-table-column>
          <el-table-column label="组团成员" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="viewDetails(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeTeam" background
          @current-change="handleCurrentTeam" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalTeam"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <!-- 参与赠送记录 -->
      <el-tab-pane label="参与赠送记录" name="twelve" v-if="fitersChooseIF([23, 24])">
        <input-form :inputData="inputGiftrecord" @toParentVal="searchGiftrecord" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-table v-loading="loading" :data="GiftrecordList"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
          <el-table-column prop="taskType" label="获赠类型">
            <template slot-scope="scope">
              <span>{{ fitersTypeValue(scope.row.taskType) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="获赠时间"> </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeGiftrecord" background
          @current-change="handleCurrentGiftrecord" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalGiftrecord"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="抽奖次数获取统计" name="thirteen" v-if="fitersChooseIF([8])">
        <input-form :inputData="wheelPrize" @toParentVal="searchWheelPrize" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData(13)"
          v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="WheelPrizeList"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
          <el-table-column prop="activityName" label="活动名称"> </el-table-column>
          <el-table-column prop="taskType" label="任务类型">
            <template slot-scope="scope">
              <span>{{ fitersTypeValueWheel(scope.row.taskType) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="giftDrawNumber" label="赠送抽奖次数"> </el-table-column>
          <el-table-column prop="joinTime" label="获取时间"> </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeWheelrecord" background
          @current-change="handleCurrentWheelrecord" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalWheelrecord"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>

      <el-tab-pane label="邀请明细" name="fourteen" v-if="fitersChooseIF([5, 6])">
        <input-form :inputData="inputInvitation" @toParentVal="searchInvitation" :btnPosition1="true"
          style="margin: 20px 0"></input-form>
        <el-button style="float: right; margin-bottom: 20px" class="expectBox" @click="exportTheData(333)"
          v-preventReClick>导出</el-button>
        <el-table v-loading="loading" :data="InvitationList"
          :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; margin: 40px auto">
          <el-table-column prop="memberNick" label="邀请人昵称"> </el-table-column>
          <el-table-column prop="inviteNick" label="被邀请人昵称"> </el-table-column>
          <el-table-column prop="invitePin" label="被邀请人openid"> </el-table-column>
          <el-table-column v-if="fitersChooseIF([5])" prop="memberLevel" label="被邀请人等级"> </el-table-column>
          <el-table-column v-if="fitersChooseIF([5])" prop="isValidInvited" label="是否有效">
            <template slot-scope="scope">
              <span>{{ scope.row.isValidInvited == 1 ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="fitersChooseIF([5])" prop="joinTime" label="入会时间"> </el-table-column>
          <el-table-column v-if="fitersChooseIF([6])" prop="joinTime" label="关注时间"> </el-table-column>
        </el-table>
        <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeInvitation" background
          @current-change="handleCurrentInvitation" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totalInvitation"
          :current-page="formList.current"></el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 团队弹框 -->
    <el-dialog title="组团明细" :visible.sync="dialogGroup" width="820px" @close="dialogGroup = false">
      <el-table :data="CouponMember" stripe style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }">
        <el-table-column prop="name" label="成员">
          <template slot-scope="scope">
            <div style="display:flex;align-items: center;">
              <div class="imgurl"><img :src="scope.row.avatar" alt="" /></div>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="joinTime" label="入团时间"> </el-table-column>
        <el-table-column prop="group" label="角色"> </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 导出弹框 -->
    <el-dialog :title="rowData.activityType == 31 ? '导出' : '身份验证'" :visible.sync="dialogExprot" width="420px"
      @close="dialogExprot = false">
      <div class="export-dialog-wrapper">
        <div class="hug-send" style="margin-top:0px;">
          <div class="send-left" style="line-height: 28px">手机号：</div>
          <div class="send-right">
            <span class="send-ipnut">
              <span>{{ loginUserInfo.mobile }}</span>
            </span>
          </div>
        </div>
        <div class="hug-send">
          <div class="send-left" style="line-height: 28px">验证码：</div>
          <div class="send-right send-right2">
            <input type="tel" class="codeBtn" v-model="code" placeholder="请输入验证码" style />
            <input type="button" class="getNumber" :class="[codeDisabled ? 'getNumber-Disabled' : '']" v-model="codeMsg"
              @click="getCode" :disabled="codeDisabled" />
          </div>
        </div>
        <div class="hug-send" style="margin-top:0px;margin-left:110px;">
          <div class="msg" style="height: 15px">{{ successMsg }}</div>
        </div>
        <div class="dialogExprot-btn">
          <el-button @click="dialogExprot = false">取消</el-button>
          <el-button type="primary" @click="getApi_Exprot">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 会员明细 -->
    <el-dialog title="邀请入会明细" :visible.sync="joinMin" width="820px" @close="joinMin = false">
      <el-table :data="joinMinList" stripe style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }">
        <el-table-column prop="inviteNick" label="被邀请人"></el-table-column>
        <el-table-column prop="invitePin" label="被邀请人openid"></el-table-column>
        <el-table-column prop="joinTime" label="入会时间"> </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 邀请关注明细 -->
    <el-dialog :title="fitersChooseIF([5]) ? '邀请开卡明细' : '邀请关注明细'" :visible.sync="inviteShow" width="820px"
      @close="inviteShow = false">
      <el-table :data="inviteInfoList" stripe style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }">
        <el-table-column prop="inviteNick" label="被邀请人"></el-table-column>
        <el-table-column prop="invitePin" label="被邀请人openid"></el-table-column>
        <el-table-column v-if="fitersChooseIF([5])" prop="memberLevel" label="会员等级"></el-table-column>
        <el-table-column v-if="fitersChooseIF([5])" prop="isValidInvited" label="是否有效" width="80px">
          <template slot-scope="scope">
            {{ scope.row.isValidInvited == 1 ? '是' : '' }}
            {{ scope.row.isValidInvited == 0 ? '否' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="joinTime" :label="fitersChooseIF([5]) ? '入会时间' : '关注时间'" width="160px">
        </el-table-column>
      </el-table>
      <el-pagination style="text-align: right; margin: 25px" @size-change="handleSizeAwardTow" background
        @current-change="handleCurrentAwardTow" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="inviteForm.size"
        layout="total, sizes, prev, pager, next, jumper" :total="inviteTotal"
        :current-page="inviteForm.current"></el-pagination>
    </el-dialog>

    <!-- 查看题目弹窗 -->
    <questionLook @close="closeQueLook" :queForm="queItem" :queData="queData" :isShowLook="isShowLook"
      :isShowData="isShowData" v-if="isShowQue"></questionLook>

    <evaluation-dialog v-model="commentDioag" :commentItem="commentItem" @dialogClose="dialogClose" />

    <!-- 批量发货 -->
    <lock-batch-dialog v-if="batchLockVisible" :visible="batchLockVisible" :activityId="rowData.id"
      :activityType="rowData.activityType" @close="batchLockClose"></lock-batch-dialog>

    <!-- 录入快递单号弹窗 -->
    <el-dialog :title="rowData.activityType == 31 || rowData.activityType == 35 ? '发货信息' : '录入快递单号'" width="480px"
      :visible.sync="enterCoutierNumShow" @close="blankEnterCoutierNum" class="enter_coutier_num_dialog">
      <el-form :model="enterCoutierFrom" label-width="120px">
        <el-form-item label="快递单号：">
          <el-input placeholder="请输入" v-model="enterCoutierNum" style="width: 250px"
            @keydown.native="clearInput"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="enterCoutierNumShow = false">取消</el-button>
        <el-button type="primary" @click="enterCoutierSubmit">确定</el-button>
      </template>
    </el-dialog>

    <el-dialog
      title="收货信息"
      width="500px"
      :visible.sync="addressDialog"
      @close="addressClose"
      class="enter_coutier_num_dialog"
      @comfirm="addressComfirm"
    >
    <el-form :model="addressData" label-width="150px">
        <el-form-item label="收件人：" required>
          <el-input
            placeholder="请输入"
            v-model="addressData.receiverName"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="收件人手机号：" required>
          <el-input
            placeholder="请输入"
            v-model="addressData.receiverMobile"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="收件人地区：" required>
            <el-cascader
              v-model="addressData.receiverAddress"
              :placeholder="addressData.receiverAddress.length>0?addressData.receiverAddress:'请选择'"
              style="width: 250px"
              :props="{value:'label',label:'label',children: 'children'}"
              :options="regionData">
            </el-cascader>
        </el-form-item>
        <el-form-item label="收件人详细地址：" required>
          <el-input
            placeholder="请输入"
            v-model="addressData.detailedAddress"
            style="width: 250px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="addressClose">取消</el-button>
        <el-button type="primary" @click="addressComfirm">确定</el-button>
      </template>
    </el-dialog>
    <div class="bigImg" v-if="dialogImageUrl">
      <img :src="dialogImageUrl" alt="">
      <i class="el-icon-circle-close" @click="closeBigImg"></i>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import echarts from "echarts";
import inputForm from "../../components/inputForm";
import questionLook from "@/components/querstionLook";
import evaluationDialog from "./evaluationDialog/evaluationDialog.vue";
import lockBatchDialog from "./lockBatchDialog.vue";
import {
  checkRecord,
  getCouponData,
  getActivityStatisticDetail,
  getCouponTable,
  checkList,
  awardRecord,
  awardRecNew,
  inKindList,
  exportRecord,
  exportRecNew,
  improveList,
  signIssuance,
  markingPrizeStatus,
  signIssuanceList,
  getShopGiftParticipateConver,
  getSplitCouponlist,
  getStatisticsCouponlist,
  CouponDetail,
  CouponDetailmember,
  CouponDetailID,
  commentDraw,
  getExportCode,
  getExportxlxs,
  participation,
  gameTaskRecord,
  rankList,
  appointment,
  getMemberJoinList,
  pointInviteAttentionPrize,
  pointInviteAttentionPrizeDetail,
  getGoodRecords,
  getWriteData,
  getPrizeReceiveData,
  getActivityRecordList,
  getJoinRecord,
  getQueLook,
  getWheelPrizeDetail,
  getQueData,
  markingSendStatusLockRight,
  getDataOverview,
  getMemberUpgradeRecord,
  getMemberUpgradeReceiveRecord,
  getMemberUpgradeInKindList,
  exportMemberUpgradeInKindList,
  security,
  modifyAddressInfo
} from "@/api/integralCenter/PointActivityAnalyticController";
import { purchaseActivityDetail, orderRankDetail } from "@/api/paradiseAndTaskCommonController";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import dayjs from "dayjs";
import axios from "axios";
import qs from "qs";
import { regionData } from 'element-china-area-data';
import { decrypt } from "@/api/sellerController";
import { checkSellerOwnRorNot } from "@/api/public";

export default {
  components: {
    questionLook,
    inputForm,
    evaluationDialog,
    lockBatchDialog,
  },
  props: {
    rowData: {
      type: Object,
    },
    ids1: {
      type: String | Number,
      default: "",
    },
  },
  data() {
    return {
      permissionsList:[],
      regionData,
      addressDialog:false,
      addressData:{
        recordId:'',
        receiverName:'',
        receiverMobile:'',
        detailedAddress:'',
        receiverAddress:[],
      },
      InvitationList: [],
      totalInvitation: 0,
      leveloptions: [],
      dialogImageUrl: "",
      stageList: [],//中奖阶梯
      // 控制录入快递单号弹窗
      enterCoutierNumShow: false,
      // 快递单号
      enterCoutierNum: "",
      // 弹窗表单标识
      enterCoutierFrom: {},
      // 录入快递单号当前行数据存储
      enterCoutierRowData: {},
      joinMin: false,
      joinMinList: [],
      tableShopData: [],
      multipleSelection: [],
      dialogGroup: false,
      dataSummary: [
        {
          value: "pv", // 对应tableTotal的字段
          name: "活动PV",
          tips: true, // 提示的显示隐藏
          tipsName: "活动页面访问次数，刷新一次或点击一次都算一次PV流量。", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "uv",
          name: "活动UV",
          tips: true,
          tipsName: "活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。",
          color: "#B2A8DA",
        },
        {
          value: "joinNumber",
          name: "参与人数",
          tips: true,
          tipsName: "参与活动的人数。",
          color: "#F2D0B5",
        },
        {
          value: "joinTimes",
          name: "参与次数",
          tips: true,
          tipsName: "参与活动的次数。",
          color: "#F4ACB9",
        },
        {
          value: "shareNumber",
          name: "分享人数",
          tips: false,
          tipsName: "",
          color: "#A7878E",
        },
        {
          value: "shareTimes",
          name: "分享次数",
          tips: false,
          tipsName: "",
          color: "#B8C7F3",
        },
        // {
        //   value: "participateAvg",
        //   name: "人均参与次数",
        //   tips: true,
        //   tipsName: "参与次数/参与人数。",
        //   color: "#C2CDDE",
        // },
        // {
        //   value: "scanshopUv",
        //   name: "浏览店铺人数",
        //   tips: false,
        //   tipsName: "",
        //   color: "#CAC7A1",
        // },
        // {
        //   value: "scanshopPv",
        //   name: "浏览店铺次数",
        //   tips: false,
        //   tipsName: "",
        //   color: "#E57733",
        // },
        // {
        //   value: "cartUv",
        //   name: "加购人数",
        //   tips: false,
        //   tipsName: "",
        //   color: "#D39595",
        // },
        // {
        //   value: "cartPv",
        //   name: "加购次数",
        //   tips: false,
        //   tipsName: "",
        //   color: "#C2D1C8",
        // },
        // {
        //   value: "followshopUv",
        //   name: "新增粉丝人数",
        //   tips: false,
        //   tipsName: "",
        //   color: "#BB7495",
        // },
        // {
        //   value: "followshopPv",
        //   name: "新增粉丝次数",
        //   tips: false,
        //   tipsName: "",
        //   color: "#96AA08",
        // },
        // {
        //   value: "followskuUv",
        //   name: "新增商品关注人数",
        //   tips: false,
        //   tipsName: "",
        //   color: "#77B2BD",
        // },
        // {
        //   value: "followskuPv",
        //   name: "新增商品关注次数",
        //   tips: false,
        //   tipsName: "",
        //   color: "#D6BF50",
        // },
      ],
      tatal_num: {
        users: 0, //活动参与用户15天内下单用户量
        ordNum: 0, //活动参与⽤户15天内下单订单总量
        gmv: 0, //活动参与⽤户15天内下单转化金额(元)
        ordRate: 0, //活动参与⽤户15天内下单转化率
      },
      hostList: [
        {
          name: "下单用户量",
          nameOne: 100,
        },
        {
          name: "下单订单总量",
          nameOne: 100,
        },
        {
          name: "下单金额",
          nameOne: 100,
        },
        {
          name: "下单转化率",
          nameOne: 100,
        },
      ],
      loading: false,
      activeName: "first",
      activityTable: [],
      signInTable: [],
      awardTable: [],
      joinTable: [],
      exchangeGoodsTable: [],
      distributionTable: [],
      inkindTable: [],
      userInfoTable: [],
      GiftrecordList: [],
      WheelPrizeList: [],
      writeTable: [],
      prizeReceiveTable: [],
      queryForm: {
        evaluateTime: "7",
      },
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      tableTotal: {
        pv: 0, //会员中心首页PV
        uv: 0, //会员中心首页uv
        // incrJoinNumber: [], //参与人数今日增量
        joinNumber: 0, //参与人数
        joinTimes: 0, //参与人次
        perJoinNumber: 0, //人均参与次数
        incrMemberCount: 0,//新增入会人数
        incrFollowCount: 0,//新增关注人数
        shareNumber: 0,//分享人数
        shareTimes: 0,//分享次数
        payGmv: 0,//已付款GMV
        successOrderItemPayCount: 0,//成交商品数(已付款)
        successOrderPayCount: 0,//成交订单数(已付款)
        confirmReceiptItemCount: 0,//成交商品数(已收货)
        confirmReceiptOrderCount: 0,//成交订单数(已收货)
        minStagePrizeCount: 0,//满足最低阶梯中奖人数(下单达到最低阶梯累计金额)
        claimPrizeCount: 0,//已领奖人数
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //折线图数据
      myCharts: null,
      chartEffectDetail: [],
      totalNum: 0,
      totalAward: 0,
      totalMail: 0,
      totalSignIn: 0,
      totalInkind: 0,
      totalUserInfo: 0,
      totalDistribution: 0, //发放记录
      totalCoupon: 0,
      totalCouponstatistics: 0,
      totalTeam: 0,
      totalComment: 0,
      totalParticipat: 0,
      totalGiftrecord: 0,
      totalWrite: 0,
      totalWheelrecord: 0,
      totalPrizeReceive: 0,
      formList: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      orderList: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      },
      inputData: [
        // {
        //   name: "用户pin:",
        //   val: "pin",
        //   placeholder: "请输入",
        // },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "签到时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputParticipat: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "得分:",
          iptArr: [
            { val: "startScore", placeholder: "请输入" },
            { val: "endScore", placeholder: "请输入" },
          ],
        },
        {
          name: "是否通关:",
          val: "isPass",
          placeholder: "请选择",
          selectArr: [
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "是否抽奖:",
          val: "isDraw",
          placeholder: "请选择",
          selectArr: [
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "是否中奖:",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
      ],
      inputfulfil: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputOrder: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["joinTimeStart", "joinTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "是否领取奖品:",
          val: "isReceive",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已领取", id: 1 },
            { label: "未领取", id: 0 },
          ],
        },
      ],
      inputAwardOrd: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "未中奖", id: 1 },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ],
        },
      ],
      inputAwardOrd26: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已发放", id: 3 },
            { label: "已中奖", id: 2 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 9 },
            { label: "待领取", id: 8 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ],
        },
        {
          name: "是否填写地址:",
          val: "isWriteAddress",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "已填写", id: 1 },
            { label: "未填写", id: 0 },
          ],
        },
      ],
      inputAwardOrd28: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["createStartTime", "createEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "是否发生升级:",
          val: "isUpgrades",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: -1 },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
        {
          name: "最新访问活动时间:",
          myDate: true,
          val: ["latestJoinStartTime", "latestJoinEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "是否领取奖品:",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: -1 },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
      ],
      inputAward29: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },

        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ]
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
                   { label: "全部", id: "" },
            { label: "未发放 ", id: 7 },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
        {
          name: "领奖时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },

        {
          name: "发放时间:",
          myDate: true,
          val: ["startPointTime", "endPointTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputData30: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },

        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "未发货", id: '2,7' },
            { label: "已发货", id: '3,5' },
          ],
        },
        {
          name: "发货时间:",
          myDate: true,
          val: ["startDeliveryTime", "endDeliveryTime"],
          startPlaceholder: "开始时间",
          endPlaceholder: "结束时间",
        },
      ],
      inputAward: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发放状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "未中奖", id: 1 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 9 },
            { label: "待领取", id: 8 },
            { label: "待发放", id: 2 },
            { label: "未发放", id: 7 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardSpecial1: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "已中奖", id: 2 },
            { label: "待领取", id: 8 },
            { label: "未发放", id: 7 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 9 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "备注时间:",
          myDate: true,
          val: ["startRemarkTime", "endRemarkTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardSpecial8: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "未中奖", id: 1 },
            { label: "待领取", id: 8 },
            { label: "已中奖", id: 2 },
            { label: "未发放", id: 7 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 9 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "备注时间:",
          myDate: true,
          val: ["startRemarkTime", "endRemarkTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardSpecial19: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发放状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "未中奖", id: 1 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 9 },
            { label: "待领取", id: 8 },
            { label: "待发放", id: 2 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "订单状态:",
          val: "orderState",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "卖家部分发货", id: 1 },
            { label: "等待确认收货", id: 2 },
            { label: "等待卖家发货", id: 3 },
            { label: "完成", id: 4 },
          ],
        },
        {
          name: "备注时间:",
          myDate: true,
          val: ["startRemarkTime", "endRemarkTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      pointExchageForm: [ // 积分兑换form表单
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发放状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "已发放", id: 3 },
            { label: "未发放", id: 7 },
          ],
        },
        {
          name: "兑换商品:",
          val: "prizeName",
          placeholder: "请输入",
        },
        {
          name: "兑换时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardJoin: [
        // {
        //   name: "用户pin:",
        //   val: "pin",
        //   placeholder: "请输入",
        // },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "未中奖", id: 1 },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            // { label: "京豆", id: 2 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            // { label: "京东E卡", id: 5 },
            // { label: "爱奇艺会员", id: 6 },
            // { label: "PLUS会员", id: 7 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardOne: [
        // {
        //   name: "用户pin:",
        //   val: "pin",
        //   placeholder: "请输入",
        // },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发放状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
          ],
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "优惠券", id: 1 },
            { label: "京豆", id: 2 },
            { label: "店铺积分", id: 4 },
          ],
        },
        {
          name: "参与时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputAwardTwo: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "预约时间:",
          myDate: true,
          val: ["joinTimeStart", "joinTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: '' },
            { label: "未发货", id: '2,7' },
            { label: "已发货", id: '5' },
          ],
        },
        {
          name: "是否填写地址:",
          val: "isFillAddress",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: '' },
            { label: "已填写", id: 1 },
            { label: "未填写", id: 0 },
          ],
        },
      ],
      inputInkind: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputIfulfil: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: this.rowData.activityType == 35 ? [
            { label: "全部", id: '' },
            { label: "未发货", id: '0' },
            { label: "已发货", id: '1' },
          ] : [
            { label: "全部", id: '' },
            { label: "未发货", id: '2,7' },
            { label: "已发货", id: '5' },
          ],
        },
        {
          name: "发货时间:",
          myDate: true,
          val: ["startDeliveryTime", "endDeliveryTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发放时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputQuestion: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "发货状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: '' },
            { label: "未发货", id: '2,7' },
            { label: "已发货", id: '3,5' },
          ],
        },
        {
          name: "发货时间:",
          myDate: true,
          val: ["startDeliveryTime", "endDeliveryTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "中奖时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputInkindSpecial: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "备注时间:",
          myDate: true,
          val: ["startRemarkTime", "endRemarkTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputUserInfo: [
        {
          name: "时间范围:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "生日:",
          myDate: true,
          type: "month",
          format: "M月",
          valueFormat: "M月",
          val: ["birthDayStart", "birthDayEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "性别:",
          val: "sex",
          selectArr: [
            { label: "全部", id: 0, defaultValue: 0 },
            { label: "男", id: 1 },
            { label: "女", id: 2 },
          ],
        },
        {
          name: "职业:",
          val: "jobs",
          placeholder: "多文本输入请用,分隔",
        },
      ],
      inputCoupon: [
        // {
        //   name: "用户pin:",
        //   val: "pin",
        //   placeholder: "请输入",
        // },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "领取时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputSplitCoupon: [
        {
          name: "统计时间:",
          myDate: true,
          type: "date",
          valueFormat: "yyyy-MM-dd",
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputGroupCoupon: [
        {
          name: "统计时间:",
          myDate: true,
          type: "date",
          valueFormat: "yyyy-MM-dd",
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputComment: [
        // {
        //   name: "用户昵称:",
        //   val: "nickName",
        //   placeholder: "请输入",
        // },
        {
          name: "订单号:",
          val: "orderId",
          placeholder: "请输入",
        },
        {
          name: "评价时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "过滤状态:",
          val: "filterType",
          placeholder: "请输入",
          selectArr: [
            { label: "未通过", id: 0 },
            { label: "通过", id: 1 },
          ],
        },
      ],
      inputInvitation: [
        {
          name: "邀请人昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "被邀请人昵称:",
          val: "inviteNick",
          placeholder: "请输入",
        },
      ],
      inputGiftrecord: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "获赠类型:",
          val: "taskType",
          placeholder: "请输入",
          selectArr: [
            { label: "每日打卡", id: 1 },
            { label: "浏览店铺", id: 2 },
            { label: "浏览商品", id: 3 },
            // { label: "加购商品", id: 4 },
            { label: "浏览会场", id: 5 },
            { label: "关注店铺", id: 6 },
            { label: "开卡入会", id: 7 },
            { label: "好友助力", id: 8 },
          ],
        },
        {
          name: "获赠时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputDataThir3: [
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入用户昵称：",
        },

        {
          name: "中奖状态：",
          val: "isWin",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "已中奖", id: 1 },
            { label: "未中奖", id: 0 },
            { label: "待开奖", id: 2 },
          ],
        },
        {
          name: "预约时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
      ],
      inputWriteData: [
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入用户昵称：",
        },
        {
          name: "填写时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "生日时间：",
          myDate: true,
          val: ["startBirthTime", "endBirthTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "最后领取奖品时间：",
          myDate: true,
          val: ["startLastPrizeTime", "endLastPrizeTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
      ],
      inputPrizeReceive: [
        {
          name: "用户昵称：",
          val: "memberNick",
          placeholder: "请输入用户昵称：",
        },
        {
          name: "领取时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "奖品类型：",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ],
        },
        {
          name: "生日时间：",
          myDate: true,
          val: ["startBirthTime", "endBirthTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "中奖状态：",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            // { label: "未中奖", id: 1 },
            { label: "已发放", id: 3 },
            { label: "已中奖", id: 2 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 9 },
            { label: "待领取", id: 8 },
          ],
        },
        {
          name: "备注时间:",
          myDate: true,
          val: ["startRemarkTime", "endRemarkTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      wheelPrize: [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "任务类型:",
          val: "taskType",
          placeholder: "请输入",
          selectArr: [
            { label: "全部", id: '' },
            { label: "关注店铺", id: 6 },
            { label: "新客赠送", id: 10 },
            { label: "会员赠送", id: 7 },
            { label: "老客赠送", id: 11 },
            { label: "预售赠送", id: 12 },
            { label: "付款订单赠送", id: 13 },
            { label: "收货订单赠送", id: 14 },
            { label: "消耗积分获取次数", id: 15 },
          ],
        },
        {
          name: "获取时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      couponDetailsList: [],
      CouponStatisticsList: [],
      TeamDetailsList: [],
      CommentList: [],
      exchangeList: [],
      CouponMember: [],
      ParticipatTable: [],
      commentItem: {},
      commentDioag: false,

      dialogExprot: false,
      codeMsg: "获取验证码",
      code: "",
      phone: "",
      successMsg: "",
      timer: "",
      countdown: 60,
      codeDisabled: false,
      ExprotData: "",

      // 中奖记录--邀请人明细弹窗
      inviteShow: false,
      inviteInfoList: [],
      inviteRowData: {},
      inviteForm: {},
      inviteTotal: '',

      //问卷
      isShowQue: false,
      isShowLook: false,
      isShowData: false,
      queData: [],//问卷统计
      queItem: [],//查看问卷

      //批量发货
      batchLockVisible: false,
    };
  },
  filters: {
    // showextendInfo(obj) {
    //   let obj1 = JSON.parse(obj);
    //   let string = "";
    //   for (const key in obj1) {
    //     if (obj1.hasOwnProperty(key)) {
    //       let key1 = key;
    //       let val = obj1[key];
    //       string += key1 + ":" + val + "; ";
    //     }
    //   }

    //   return string;
    // },
    // 只要年月日，裁剪空格后的时分秒
    spliceDate(Str) {
      let newStr = Str ? Str.substring(0, Str.indexOf(" ")) : '';
      console.log('newStr', newStr);
      return newStr;
    }
  },
  computed: {
    ...mapState(["loginUserInfo"]),
    permissions() {
      return this.$store.state.loginUserInfo.permissions;
    },
    inputAwardSpecial34() {
      const arr = [
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "中奖所属阶梯:",
          val: "stage",
          placeholder: "请选择",
          selectArr: this.stageList,
        },
        {
          name: "奖品类型:",
          val: "prizeType",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "" },
            { label: "优惠券", id: 1 },
            { label: "实物", id: 3 },
            { label: "店铺积分", id: 4 },
            { label: "现金红包", id: 8 },
            { label: "实物（专属下单）", id: 10 },
          ],
        },
        {
          name: "中奖状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: this.rowData.activityType == 35 ? [
            { label: "全部", id: "" },
            { label: "已中奖", id: 0 },
            { label: "已发放", id: 1 },
            { label: "发放失败", id: 2 },
          ] : [
            { label: "全部", id: "" },
            { label: "已发放", id: 3 },
            { label: "已中奖", id: 2 },
            { label: "发放失败", id: 4 },
            { label: "已失效", id: 9 },
            { label: "待领取", id: 8 },
          ]
        },
        {
          name: "参与时间:",
          myDate: true,
          val: this.rowData.activityType == 35 ? ["joinTimeStart", "joinTimeEnd"] : ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "发放时间:",
          myDate: true,
          val: this.rowData.activityType == 35 ? ["sendTimeStart", "sendTimeEnd"] : ["startPointTime", "endPointTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        }
      ]
      if (this.rowData.activityType == 34) {
        arr.push({
          name: "备注时间:",
          myDate: true,
          val: ["startRemarkTime", "endRemarkTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        })
      }
      return arr
    }
  },
  created() {
    if (this.rowData.activityType == 31) {
      this.inputAwardOrd[4] = {
        name: "是否填写地址:",
        val: "isWriteAddress",
        placeholder: "请选择",
        selectArr: [
          { label: "全部", id: "", defaultValue: '' },
          { label: "已填写", id: 1 },
          { label: "未填写", id: 0 },
        ],
      }
      this.inputAwardOrd.forEach(item => {
        if (item.val == 'status') {
          item.selectArr = [
            { label: "未中奖", id: 1 },
            { label: "已中奖", id: 2 },
            { label: "已发放", id: 3 },
            { label: "发放失败", id: 4 },
            { label: "未发放", id: 7 },
          ]
        }
      })
    }
    if (this.rowData.activityType == 34) {
      this.inputIfulfil.push({
        name: "备注时间:",
        myDate: true,
        val: ["startRemarkTime", "endRemarkTime"],
        startPlaceholder: "开始日期",
        endPlaceholder: "结束日期",
      })
    }
  },
  async mounted() {
    checkSellerOwnRorNot({ids: '10290'}).then(res=>{
      if (res.code == 200) {
        this.permissionsList = res.data
      }
    })
    if (this.fitersChooseIF([6])) {
      this.inputInvitation.push({
        name: `关注时间:`,
        myDate: true,
        val: ["startTime", "endTime"],
        startPlaceholder: "开始日期",
        endPlaceholder: "结束日期",
      })
    }
    if (this.fitersChooseIF([5])) {
      this.inputInvitation.push({
        name: "是否有效:",
        val: "isValidInvited",
        placeholder: "请输入",
        selectArr: [
          { label: "全部", id: '' },
          { label: "否", id: 0 },
          { label: "是", id: 1 },
        ],
      })
      this.inputInvitation.push({
        name: `入会时间:`,
        myDate: true,
        val: ["startTime", "endTime"],
        startPlaceholder: "开始日期",
        endPlaceholder: "结束日期",
      })
    }
    if (this.rowData.activityType == 28) {
      this.dataSummary = [
        {
          value: "uv", // 对应tableTotal的字段
          name: "点击人数",
          tips: false, // 提示的显示隐藏
          tipsName: "活动页面访问次数，刷新一次或点击一次都算一次PV流量。", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "pv",
          name: "点击次数",
          tips: false,
          tipsName: "活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。",
          color: "#B2A8DA",
        },
        {
          value: "perClickNumber",
          name: "人均点击次数",
          tips: false,
          tipsName: "参与活动的人数。",
          color: "#F2D0B5",
        },
      ];
    } else if (this.rowData.activityType == 18) {
      this.dataSummary = [
        {
          value: "pv", // 对应tableTotal的字段
          name: "活动PV",
          tips: true, // 提示的显示隐藏
          tipsName: "活动页面访问次数，刷新一次或点击一次都算一次PV流量。", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "uv",
          name: "活动UV",
          tips: true,
          tipsName: "活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。",
          color: "#B2A8DA",
        },
        {
          value: "joinNumber",
          name: "参与人数",
          tips: true,
          tipsName: "参与活动的人数。",
          color: "#F2D0B5",
        },
        {
          value: "joinTimes",
          name: "参与次数",
          tips: true,
          tipsName: "参与活动的次数。",
          color: "#F4ACB9",
        },
        {
          value: "shareNumber",
          name: "分享人数",
          tips: false,
          tipsName: "",
          color: "#A7878E",
        },
        {
          value: "shareTimes",
          name: "分享次数",
          tips: false,
          tipsName: "",
          color: "#B8C7F3",
        },
        {
          value: "payGmv",
          name: "已付款GMV",
          tips: false,
          tipsName: "",
          color: "#C2CDDE",
        }
      ];
    } else if (this.rowData.activityType == 29) {
      this.dataSummary = [
        {
          value: "joinNumber",
          name: "参与人数",
          tips: false,
          tipsName: "参与活动的人数。",
          color: "#F2D0B5",
        },
        {
          value: "joinTimes",
          name: "参与次数",
          tips: false,
          tipsName: "",
          color: "#BB7495",
        },
        {
          value: "perJoinNumber",
          name: "人均参与次数",
          tips: false,
          tipsName: "",
          color: "#96AA08",
        },
      ];
    } else if (this.rowData.activityType == 30) {
      this.dataSummary = [
        {
          value: "uv", // 对应tableTotal的字段
          name: "点击人数",
          tips: false, // 提示的显示隐藏
          tipsName: "活动页面访问次数，刷新一次或点击一次都算一次PV流量。", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "pv",
          name: "点击次数",
          tips: false,
          tipsName: "活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。",
          color: "#B2A8DA",
        },
        {
          value: "joinNumber",
          name: "参与人数",
          tips: false,
          tipsName: "参与人数",
          color: "#F2D0B5",
        },
      ];
    } else if (this.rowData.activityType == 34) {
      this.dataSummary = [
        {
          value: "pv", // 对应tableTotal的字段
          name: "活动PV",
          tips: false, // 提示的显示隐藏
          tipsName: "活动页面访问次数，刷新一次或点击一次都算一次PV流量。", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "uv",
          name: "活动UV",
          tips: false,
          tipsName: "活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。",
          color: "#B2A8DA",
        },
        {
          value: "incrMemberCount",
          name: "新增入会人数",
          tips: false,
          tipsName: "新增入会人数",
          color: "#F2D0B5",
        },
        {
          value: "incrFollowCount",
          name: "新增关注人数",
          tips: false,
          tipsName: "新增关注人数",
          color: "#F4ACB9",
        },
        {
          value: "shareNumber",
          name: "分享人数",
          tips: false,
          tipsName: "",
          color: "#A7878E",
        },
        {
          value: "shareTimes",
          name: "分享次数",
          tips: false,
          tipsName: "",
          color: "#B8C7F3",
        },
        {
          value: "joinTimes",
          name: "参与次数",
          tips: false,
          tipsName: "参与次数",
          color: "#CAC7A1",
        },
        {
          value: "joinNumber",
          name: "参与人数",
          tips: false,
          tipsName: "参与人数",
          color: "#C2CDDE",
        },
        {
          value: "payGmv",
          name: "已付款GMV",
          tips: false,
          tipsName: "已付款GMV",
          color: "#E57733",
        },
        {
          value: "successOrderPayCount",
          name: "成交订单数(已付款)",
          tips: false,
          tipsName: "",
          color: "#C2D1C8",
        },
        {
          value: "successOrderItemPayCount",
          name: "成交商品数(已付款)",
          tips: false,
          tipsName: "",
          color: "#D39595",
        },
        {
          value: "confirmReceiptOrderCount",
          name: "成交订单数(已收货)",
          tips: false,
          tipsName: "",
          color: "#BB7495",
        },
        {
          value: "confirmReceiptItemCount",
          name: "成交商品数(已收货)",
          tips: false,
          tipsName: "",
          color: "#96AA08",
        },
        {
          value: "minStagePrizeCount",
          name: "满足最低阶梯中奖人数(下单达到最低阶梯累计金额)",
          tips: false,
          tipsName: "",
          color: "#77B2BD",
        },
        {
          value: "claimPrizeCount",
          name: "已领奖人数",
          tips: false,
          tipsName: "",
          color: "#D6BF50",
        }
      ];
    } else if (this.rowData.activityType == 35) {
      this.dataSummary = [
        {
          value: "pv", // 对应tableTotal的字段
          name: "活动PV",
          tips: false, // 提示的显示隐藏
          tipsName: "活动页面访问次数，刷新一次或点击一次都算一次PV流量。", // 提示语
          color: "#EFB37E", // 折现颜色
        },
        {
          value: "uv",
          name: "活动UV",
          tips: false,
          tipsName: "活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。",
          color: "#B2A8DA",
        },
        {
          value: "openCardNum",
          name: "新增入会人数",
          tips: false,
          tipsName: "新增入会人数",
          color: "#F2D0B5",
        },
        {
          value: "followNum",
          name: "新增关注人数",
          tips: false,
          tipsName: "新增关注人数",
          color: "#F4ACB9",
        },
        {
          value: "shareNum",
          name: "分享人数",
          tips: false,
          tipsName: "",
          color: "#A7878E",
        },
        {
          value: "shareTime",
          name: "分享次数",
          tips: false,
          tipsName: "",
          color: "#B8C7F3",
        },
        {
          value: "joinTimes",
          name: "参与次数",
          tips: false,
          tipsName: "参与次数",
          color: "#CAC7A1",
        },
        {
          value: "joinNum",
          name: "参与人数",
          tips: false,
          tipsName: "参与人数",
          color: "#C2CDDE",
        },
        {
          value: "orderAmt",
          name: "已付款GMV",
          tips: false,
          tipsName: "已付款GMV",
          color: "#E57733",
        },
        {
          value: "orderPayNum",
          name: "成交订单数(已付款)",
          tips: false,
          tipsName: "",
          color: "#C2D1C8",
        },
        {
          value: "orderPayItemNum",
          name: "成交商品数(已付款)",
          tips: false,
          tipsName: "",
          color: "#D39595",
        },
        {
          value: "orderFinishNum",
          name: "成交订单数(已收货)",
          tips: false,
          tipsName: "",
          color: "#BB7495",
        },
        {
          value: "orderItemNum",
          name: "成交商品数(已收货)",
          tips: false,
          tipsName: "",
          color: "#96AA08",
        },
        {
          value: "winNum",
          name: "满足最低阶梯中奖人数(下单达到最低阶梯累计金额)",
          tips: false,
          tipsName: "",
          color: "#77B2BD",
        },
        {
          value: "receiveNum",
          name: "已领奖人数",
          tips: false,
          tipsName: "",
          color: "#D6BF50",
        }
      ];
    }
    this.timeChange();
    await this.queryTotal();
    await this.initChart(); //折线图
    //下单转化数据
    this.getShopGiftParticipateConver();
    if (this.rowData.activityType == 24) this.inputParticipat.splice(2, 1);
    // console.log(this.rowData,'111111111111111111111111111');
  },
  methods: {
    addressClose(){
      this.addressDialog = false
    },
    addressComfirm(){
      let postData = {
        ...this.addressData
      }
      postData.receiverAddress = postData.receiverAddress.join('')
      if(!postData.receiverName){
        this.$message.warning('请填写收件人')
        return
      }else if(!postData.receiverMobile){
        this.$message.warning('请填写收件人手机号')
        return
      }else if(!postData.detailedAddress){
        this.$message.warning('请填写收件人详细地址')
        return
      }else if(!postData.receiverAddress){
      this.$message.warning('请选择收件人地区')
        return
      }
      modifyAddressInfo(postData).then(res=>{
        if(res.code==1){
          this.$message.success('修改成功')
          this.addressDialog = false
          this.$refs.export_fun.submitForm('formSearch', true);
        }
      })
      console.log("this.addressData",this.addressData)
    },
    eduitAdress(row) {
      this.addressDialog = true
      let securityArr = {
        decryptDetailedAddress: row.decryptDetailedAddress,
        decryptReceiverAddress: row.decryptReceiverAddress,
        decryptReceiverMobile: row.decryptReceiverMobile,
        decryptReceiverName: row.decryptReceiverName,
      }
      this.addressData.recordId = row.recordId
      Object.keys(securityArr).forEach(key => {
        if (securityArr[key]) {
          security({
            type: key == 'decryptReceiverMobile' ? 'phone' : 'simple',
            content: securityArr[key],
            venderId: this.loginUserInfo.sellerId,
            isEncrypt: false
          }).then((res) => {
            if (key == 'decryptReceiverMobile') {
              this.addressData.receiverMobile = res
            } else if (key == 'decryptReceiverName') {
              this.addressData.receiverName = res
            } else if (key == 'decryptDetailedAddress') {
              this.addressData.detailedAddress = res
            } else if (key == 'decryptReceiverAddress') {
              this.addressData.receiverAddress = [res]
            }
            console.log('this.addressData', this.addressData)
          })
        }
      });
    },
    getLevel() {
      querymemberLevel()
        .then((res) => {
          this.leveloptions = res.data
        })
        .catch((res) => { });
    },
    closeBigImg() {
      this.dialogImageUrl = "";
    },
    // 放大图片
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
    },
    showextendInfo(obj) {
      let obj1 = obj ? JSON.parse(obj) : {};
      let arr = []
      for (const key in obj1) {
        if (obj1.hasOwnProperty(key)) {
          let keys = key;
          let isImg = false
          let val = ""
          if (this.isLink(obj1[key]).flag) {
            isImg = true
          }
          console.log(this.isLink(obj1[key]), '4444');
          val = this.isLink(obj1[key]).newVal;
          arr.push({ prop: keys, keys: val, isImg })
        }
      }
      return arr;
    },
    isLink(val) {
      let newVal = ""
      let flag = false
      let reg = new RegExp(/^http|https?:\/\//)
      if (val.indexOf("[") != -1) {
        flag = reg.test(val)
        newVal = JSON.parse(val)
      } else {
        newVal = val
      }
      return { flag, newVal }
    },
    // 批量标记发放
    batchMark(source) {
      if (this.multipleSelection.length == 0) return this.$message.warning("请先勾选有效数据再操作");
      let ids = this.multipleSelection.map((item, index) => item.recordId);
      // let index
      // console.log(arr)
      // return
      signIssuanceList(ids).then(res => {
        this.winningRecord()
        this.multipleSelection = [];
        this.$message.success(res.message);
      })

    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //入会打榜--被邀请人明细
    winningDetails(val) {
      this.joinMin = true;
      let params = {
        activityId: this.formList.activityId,
        memberNick: val.memberNick
      }
      getMemberJoinList(params).then((res) => {
        this.joinMinList = res.data
      }).catch((res) => { })
    },
    //中奖记录--被邀请人明细
    openInviteInfo(val) {
      this.inviteShow = true
      // console.log(val);
      this.inviteForm = {
        activityId: this.formList.activityId,
        memberNick: val.memberNick,
        pin: val.pin,
        current: 1,
        size: 10
      }
      this.inviteRowData = val
      pointInviteAttentionPrizeDetail(this.inviteForm).then((res) => {
        this.inviteInfoList = res.data.records
        this.inviteTotal = res.data.total
        console.log(res);
      })
      // this.inviteInfoList = val.inviteDetailList
    },
    export_fun() {
      if (this.rowData.activityType == 35) {
        this.exportTheData(21)
      } else {
        this.$refs.export_fun.export_fun();
      }
    },
    export_get(params) {
      // console.log("params", params);
      this.ExprotData = params;
      clearInterval(this.timer);
      this.codeMsg = "获取验证码";
      (this.successMsg = ""), (this.code = "");
      (this.countdown = 60), (this.codeDisabled = false), (this.dialogExprot = true);
      // this.dialogGroup = true
    },
    getCode() {
      // 验证码60秒倒计时
      if (!this.codeDisabled) {
        getExportCode({ sendType: 9, mobile: this.$store.state.loginUserInfo.decryptionMobile }).then((res) => {
          if (res.code == 200) {
            this.codeDisabled = true;

            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "已发送(" + this.countdown + "s)";
                  // this.successMsg = "验证码错误！"
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "重新获取";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.successMsg = res.message;
          }
        });
      }
    },
    getApi_Exprot() {
      // 添加验证码校验
      if (!this.code){
        return this.$message.warning('请输入验证码')
      }
      let params = {
        activityId: this.formList.activityId,
        startTime: this.ExprotData.startTime || "",
        endTime: this.ExprotData.endTime || "",
        code: this.code,
        memberNick: this.ExprotData.memberNick,
        current: 1,
        size: 9999999,
      };
      if (this.$route.query.activityType == 30) {
        let obj = this.$refs.export_fun.export_fun2();
        params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
          subType: 30
        }
      }
      console.log('this.rowData------>', this.rowData)
      if ([1, 8, 19, 26, 34].includes(this.rowData.activityType)) {
        params.startRemarkTime = this.formList.startRemarkTime
        params.endRemarkTime = this.formList.endRemarkTime
      }
      if (this.rowData.activityType == 31) {
        params.status = this.ExprotData.status;
        params.startDeliveryTime = this.ExprotData.startDeliveryTime;
        params.endDeliveryTime = this.ExprotData.endDeliveryTime;
      }
      console.log(params, 666666);
      getExportxlxs(params).then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.successMsg = "";
          this.dialogExprot = false;
          let Time = new Date().toLocaleString();
          var blob = new Blob([res.blob]);
          var link = document.createElement("a"); //a标签下载
          link.href = window.URL.createObjectURL(blob);
          link.download = "实物奖品名单" + Time + ".xls";
          link.click();
          window.URL.revokeObjectURL(link.href);
          // }
        } else {
          this.successMsg = res.message;
        }
      });
    },
    // 返回value
    fitersTypeValue(val) {
      let arr = ["", "每日打卡", "浏览店铺", "浏览商品", "加购商品", "浏览会场", "关注店铺", "开卡入会", "好友助力"];
      return arr[val];
    },
    fitersTypeValueWheel(val) {
      let arr = ["", "每日打卡", "浏览店铺", "浏览商品", "加购商品", "浏览会场", "关注店铺", "开卡入会", "好友助力", "消耗积分兑换", "新客赠送", "老客赠送", "预售商品支付定金赠送", "消费赠送（已收款）", "消费赠送（已收货）", "消耗积分获取次数"];
      return arr[val];
    },
    // 活动类型 三元表达式 判断显示文字
    fitersRepurchase(arr, val1, val2) {
      console.log('this.rowData.activityType------>', this.rowData.activityType)
      let isfaly = false;
      arr.forEach((item) => {
        if (this.rowData.activityType == item) {
          isfaly = true;
        }
      });
      return isfaly ? val1 : val2;
    },
    // this.rowData.activityType活动类型判断显示隐藏type === "=="则arr里面显示,type === "！="   则arr里面不显示
    fitersChooseIF(arr, type = "==") {
      if (type === "==") {
        let isfaly = false;
        arr.forEach((item) => {
          if (this.rowData.activityType == item) {
            isfaly = true;
          }
        });
        return isfaly;
      } else {
        let isfaly = true;
        arr.forEach((item) => {
          if (this.rowData.activityType == item) {
            isfaly = false;
          }
        });
        return isfaly;
      }
    },
    //下单转化数据
    getShopGiftParticipateConver() {
      let tt = "00:00:00",
        start = "",
        end = "",
        startTime = "",
        endTime = "";
      if (this.queryForm.evaluateTime == 0) {
        if (this.postForm.startDate == "" || this.postForm.endDate == "") {
          this.$message({
            message: "自定义时间不能为空！",
            type: "warning",
          });
          return;
        }
        start = `${this.postForm.startDate} ${tt}`;
        end = `${this.postForm.endDate} ${tt}`;
      }
      if (this.queryForm.evaluateTime == 0) {
        startTime = start;
        endTime = end;
      } else {
        startTime = this.postForm.startDate;
        endTime = this.postForm.endDate;
      }
      // getShopGiftParticipateConver({ activityId: this.formList.activityId, startTime, endTime })
      //   .then((res) => {
      //     console.log(res);
      //     if (res.code == 1) {
      //       this.tatal_num = res.data;
      //     } else {
      //       this.tatal_num = {
      //         gmv: 0,
      //         newShopGmv: 0,
      //         newShopUsers: 0,
      //         ordNum: 0,
      //         ordRate: 0,
      //         users: 0,
      //       };
      //     }
      //   })
    },
    //返回列表
    toSetting() {
      sessionStorage.setItem("goBack", 1);
      this.$emit("returnStep");
    },
    //页头点击
    async handleClick(tab, event) {
      this.formList.size = 10;
      this.formList.current = 1;
      // 活动统计
      if (tab.name === "first") {
        await this.queryTotal();
        await this.initChart();
        this.getShopGiftParticipateConver();
      }
      // 签到纪录
      if (tab.name === "second") {
        this.checkRecord();
      }
      // 积分兑换明细
      if (tab.name === "thirtyThree") {
        this.searchExchangeList()
      }
      //打榜记录
      if (tab.name === "twentyFive") {
        this.rankListOne()
      }
      // 中奖记录
      if (tab.name === "third") {
        if (this.$refs.searchForm) {
          this.$refs.searchForm.resetForm();
        }
        this.winningRecord();
      }
      // 实物奖品
      if (tab.name === "four") {
        if (this.$refs.export_fun) {
          this.$refs.export_fun.resetForm();
        }
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.inKingRecord();
      }
      // 用户资料明细
      if (tab.name === "five") {
        this.improveRecord();
      }
      //发放记录
      if (tab.name === "six") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.distributionRecord();
      }
      //拼券明细
      if (tab.name === "seven") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.commentDraw();
      }
      //拼券明细
      if (tab.name === "eight") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.CoupondDtails();
      }
      //优惠券统计
      if (tab.name === "nine") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.CouponStatistics();
      }
      //团队详情
      if (tab.name === "ten") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.TeamDetails();
      }
      // 参与记录
      if (tab.name === "eleven") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.getParticipation();
      }
      if (tab.name === "twentyOne") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.getParticipation2();
      }
      if (tab.name === "twentySix") {
        this.formList.startTime = ""
        this.formList.endTime = ""
        if (this.rowData.activityType == 35) {
          this.getParticipation4()
        } else {
          this.getParticipation3();
        }
      }
      // 参与赠送
      if (tab.name === "twelve") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.getGameTaskRecord();
      }
      if (tab.name === "fourteen") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.getInvitation();
      }
      if (tab.name === "fifteen") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.getappointment();
      }
      if (tab.name === "fifteen") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.getappointment();
      }
      if (tab.name === "sixteen") {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.getWriteRecord();
      }
      if (tab.name === "seventeen") {
        if (this.rowData.activityType == 34) {
          this.getStageList()
        } else if (this.rowData.activityType == 35) {
          this.getStageList2()
          this.getPrizeReceiveRecord2()
          return
        }
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.getPrizeReceiveRecord();
      }
      if (tab.name === 'thirteen') {
        (this.formList.startTime = ""), (this.formList.endTime = ""), this.getWheelPrize();
      }
      if (tab.name === 'twentyEight') {
        this.getParticipation28();
      }
      if (tab.name === 'twentyNine') {
        this.getParticipation29();
      }
      if (tab.name === 'thirty') {
        this.getParticipation30();
      }
    },
    timeChange(type) {
      let self = this;
      let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      let tt = "00:00:00";
      const date = [self.getDay(-7, "-"), self.getDay(-1, "-")];
      console.log('date', date)
      this.mytime = date;
      if (type == null) {
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else if (type == 7) {
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else if (type == 15) {
        this.mytime[0] = self.getDay(-15, "-");
        this.mytime[1] = self.getDay(-1, "-");
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(-1, "-");
        this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    //获取中奖阶梯
    getStageList() {
      console.log('rowData', this.rowData)
      purchaseActivityDetail(this.rowData.id).then((res) => {
        console.log(res, res.code)
        if (res.code == 1) {
          let stagePrizeMapBack = Object.values(res.data.ruleDto.stagePrizeMap)
          console.log("stagePrizeMapBack", stagePrizeMapBack)
          this.stageList = [];
          this.stageList.push({
            label: '全部', id: ''
          })
          for (let i = 0; i < stagePrizeMapBack.length; i++) {
            let label = `阶梯 ${i + 1}`;
            let id = i + 1;
            this.stageList.push({ label, id });
          }
        }
      })
    },
    getStageList2() {
      orderRankDetail(this.rowData.id).then((res) => {
        if (res.code == 1) {
          const stageList = [{
            label: '全部', id: ''
          }
          ]
          if (res.data.prizeDTOList && res.data.prizeDTOList.length) {
            res.data.prizeDTOList.forEach(item => {
              stageList.push({
                label: `阶梯${item.taskIndex}`,
                id: item.taskIndex
              })
            })
          }
          this.stageList = stageList
        }
      })
    },
    //中奖记录批量发货
    batchLock() {
      this.batchLockVisible = true;
    },
    //中奖记录批量发货
    batchLockClose() {
      this.inKingRecord();
      this.batchLockVisible = false;
    },
    // 查询按钮
    querySeach() {
      this.formList.current = 1;
      this.formList.size = 10;
      this.queryTotal();
      this.getShopGiftParticipateConver();
    },
    //查询数据总和
    async queryTotal() {
      // this.formList.current = 1;
      let tt = "00:00:00",
        start = "",
        end = "",
        startTime = "",
        endTime = "";
      if (this.queryForm.evaluateTime == 0) {
        if (this.postForm.startDate == "" || this.postForm.endDate == "") {
          this.$message({
            message: "自定义时间不能为空！",
            type: "warning",
          });
          return;
        }
        start = `${this.postForm.startDate} ${tt}`;
        end = `${this.postForm.endDate} ${tt}`;
      }
      if (this.queryForm.evaluateTime == 0) {
        startTime = start;
        endTime = end;
      } else {
        startTime = this.postForm.startDate;
        endTime = this.postForm.endDate;
      }
      let fn = getCouponData
      // 处理下单冲榜
      if (this.rowData.activityType == 35) {
        fn = getDataOverview
        endTime = `${endTime.split(" ")[0]} 23:59:59`
      }
      fn({
        activityId: this.formList.activityId,
        startTime,
        endTime,
      })
        .then((res) => {
          this.loading = false;
          this.tableTotal = res.data;
        })
        .catch((res) => {
          // this.$message.error("输入时间错误");
        });

      //折线图数据查询
      let fn2 = checkRecord
      const query = {
        activityId: this.formList.activityId,
        startTime,
        endTime
      }
      if (this.rowData.activityType == 35) {
        fn2 = getActivityStatisticDetail
        query.size = this.formList.size
        query.current = this.formList.current
      }
      const { data } = await fn2(query);
      const dataList = this.rowData.activityType == 35 ? data.records : data
      if (dataList.length == 1 && dataList.length == 0) {
        this.$message.error("折线图时间过短");
      } else {
        this.chartEffectDetail = dataList;
        this.$nextTick(() => {
          this.initChart();
          window.addEventListener("resize", () => {
            this.myCharts.resize();
          });
        });
      }
      //列表数据查询
      getCouponTable({
        activityId: this.formList.activityId,
        size: this.formList.size,
        current: this.formList.current,
        startTime,
        endTime,
      })
        .then((res) => {
          this.loading = false;
          this.activityTable = res.data.records;
          this.totalNum = Number(res.data.total);
          // console.log(this.postForm.endDate);
        })
        .catch((res) => {
          // this.$message.error("输入时间错误1");
        });
    },
    //折线图
    initChart() {
      if (this.rowData.activityType != 15) {
        this.myCharts = echarts.init(this.$refs.payRemindChart);
        this.setOptions();
      }
    },
    //折线图事件
    setOptions() {
      const seriesList = this.dataSummary.map((item) => {
        return {
          name: item.name,
          type: "line",
          smooth: true,
          color: item.color,
          data: this.chartEffectDetail.map((i) => i[item.value]),
        };
      });
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // data: ["活动PV", "活动UV", "参与人数", "参与次数", "人均参与次数"],
          data: this.dataSummary.map((item) => item.name),
          bottom: -5,
          // left: "center",
          x: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "11%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartEffectDetail.map((item) => item.statsDate),
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: seriesList,
      };

      this.myCharts.setOption(option);
    },
    //重置
    queryOne() {
      this.formList.current = 1;
      this.formList.size = 10;
      this.queryForm.evaluateTime = "7";
      this.timeChange(7);
      this.queryTotal();
    },
    // 参与记录
    getParticipation() {
      this.loading = true;
      this.ParticipatTable = [];
      participation(this.formList)
        .then((res) => {
          console.log('111111', res.data);
          this.loading = false;
          this.ParticipatTable = res.data.records;
          this.totalParticipat = Number(res.data.total);
        })
        .catch((res) => { });
    },
    // 调查问卷--参与记录
    getParticipation2() {
      this.loading = true;
      this.ParticipatTable = [];
      getPrizeReceiveData(this.formList)
        .then((res) => {
          this.loading = false;
          console.log('22222', res.data);
          this.ParticipatTable = res.data.records;
          this.totalParticipat = Number(res.data.total);
        })
        .catch((res) => { });
    },

    // 会员升级礼--参与记录
    getParticipation28() {
      this.loading = true;
      this.ParticipatTable = [];
      // 构建查询参数
      const query = { ...this.formList }; // 先复制所有属性
      // 处理特殊字段
      if (!([0, 1].includes(this.formList.isWin))) {
        delete query.isWin;
      }
      if (!([0, 1].includes(this.formList.isUpgrades))) {
        delete query.isUpgrades;
      }
      getMemberUpgradeRecord(query)
        .then((res) => {
          this.loading = false;
          console.log('22222', res.data);
          this.ParticipatTable = res.data.records;
          this.totalParticipat = Number(res.data.total);
        })
        .catch((res) => { });
    },
    getParticipation29() {
      this.loading = true;
      this.awardTable = [];
      getMemberUpgradeReceiveRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        })
        .catch((res) => { });
    },
    getParticipation30() {
      this.loading = true;
      this.inkindTable = [];
      getMemberUpgradeInKindList(this.formList)
        .then((res) => {
          this.loading = false;
          this.inkindTable = res.data.records;
          this.totalInkind = Number(res.data.total);
        })
        .catch((res) => { });
    },
    // 满额有礼--参与记录
    getParticipation3() {
      this.loading = true;
      this.ParticipatTable = [];
      console.log("this.formList", this.formList)
      getActivityRecordList(this.formList)
        .then((res) => {
          this.loading = false;
          console.log('22222', res.data);
          this.ParticipatTable = res.data.records;
          this.totalParticipat = Number(res.data.total);
        })
        .catch((res) => { });
    },
    // 满额有礼--参与记录
    getParticipation4() {
      this.loading = true;
      this.ParticipatTable = [];
      const query = {
        current: this.orderList.current,
        size: this.orderList.size,
        source: 0, //参与记录
        id: this.rowData.id
      }
      if (this.orderList.memberNick) {
        query.memberNick = this.orderList.memberNick
      }
      if (this.orderList.joinTimeStart) {
        query.joinTimeStart = this.orderList.joinTimeStart
      }
      if (this.orderList.joinTimeEnd) {
        query.joinTimeEnd = this.orderList.joinTimeEnd
      }
      if (this.orderList.isReceive || this.orderList.isReceive === 0) {
        query.isReceive = this.orderList.isReceive
      }
      getJoinRecord(query)
        .then((res) => {
          this.loading = false;
          this.ParticipatTable = res.data.records;
          this.totalParticipat = Number(res.data.total);
        })
        .catch((res) => { });
    },
    //参与赠送
    getGameTaskRecord() {
      this.loading = true;
      gameTaskRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.GiftrecordList = res.data.records;
          this.totalGiftrecord = Number(res.data.total);
        })
        .catch((res) => { });
    },
    // 抽奖机会赠送 查看详情
    commentDetails(item) {
      this.commentItem = item;
      this.commentDioag = true;
      console.log(this.commentItem);
    },
    dialogClose() {
      this.commentDioag = false;
    },
    // 团队详情 查看详情
    async viewDetails(item) {
      const { data: res } = await CouponDetailmember(item.id);
      this.CouponMember = res.map((item, i) => {
        return {
          ...item,
          group: i == 0 ? "团长" : "团员",
        };
      });
      this.dialogGroup = true;
    },
    //签到记录
    checkRecord() {
      this.loading = true;
      checkList(this.formList)
        .then((res) => {
          this.loading = false;
          this.signInTable = res.data.records;
          this.totalSignIn = Number(res.data.total);
        })
        .catch((res) => { });
    },
    //中奖记录
    winningRecord() {
      this.loading = true;
      // 只有邀请类的调awardRecNew接口
      if (this.rowData.activityType == 5 || this.rowData.activityType == 6) {
        pointInviteAttentionPrize(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => { });
      } else if (this.rowData.activityType == 30) {
        this.formList.subType = 30
        getGoodRecords(this.formList).then(res => {
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        })
      } else if (this.rowData.activityType == 33) {
        this.searchExchangeList()
      }
      else {
        awardRecord(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => { });
      }
    },
    //填写记录
    getWriteRecord() {
      this.loading = true;
      getWriteData(this.formList)
        .then((res) => {
          this.loading = false;
          this.writeTable = res.data.records;
          this.totalWrite = Number(res.data.total);
        })
        .catch((res) => { });
    },
    // 奖品领取记录
    getPrizeReceiveRecord() {
      this.loading = true;
      console.log(this.formList, '66666666666')
      getPrizeReceiveData(this.formList)
        .then((res) => {
          this.loading = false;
          this.prizeReceiveTable = res.data.records;
          this.totalPrizeReceive = Number(res.data.total);
        })
        .catch((res) => { });
    },
    // 下单冲榜-领取记录
    getPrizeReceiveRecord2() {
      const query = {
        current: this.formList.current,
        size: this.formList.size,
        source: 1, //参与记录
        id: this.rowData.id
      }
      if (this.formList.memberNick) {
        query.memberNick = this.formList.memberNick
      }
      if (this.formList.stage || this.formList.stage === 0) {
        query.taskIndex = this.formList.stage
      }
      if (this.formList.prizeType || this.formList.prizeType === 0) {
        query.prizeType = this.formList.prizeType
      }
      if (this.formList.joinTimeStart) {
        query.joinTimeStart = this.formList.joinTimeStart
      }
      if (this.formList.joinTimeEnd) {
        query.joinTimeEnd = this.formList.joinTimeEnd
      }
      if (this.formList.sendTimeStart) {
        query.sendTimeStart = this.formList.sendTimeStart
      }
      if (this.formList.sendTimeEnd) {
        query.sendTimeEnd = this.formList.sendTimeEnd
      }
      if (this.formList.status || this.formList.status === 0) {
        query.status = this.formList.status
      }
      getJoinRecord(query)
        .then((res) => {
          this.loading = false;
          this.prizeReceiveTable = res.data.records;
          this.totalPrizeReceive = Number(res.data.total);
        })
    },
    // 预约记录
    getappointment() {
      this.loading = true;
      appointment(this.formList).then((res) => {
        this.loading = false;
        this.exchangeList = res.data.records;
        this.totalMail = Number(res.data.total);
      }).catch((res) => { });
    },
    // 兑换明细
    searchExchangeList() {
      this.loading = true;
      getPrizeReceiveData(this.formList)
        .then((res) => {
          this.loading = false;
          this.exchangeGoodsTable = res.data.records;
          this.totalAward = Number(res.data.total);
        })
        .catch((res) => { });
    },
    //打榜记录
    rankListOne() {
      this.loading = true;
      this.formList.id = this.formList.activityId
      rankList(this.formList).then((res) => {
        this.loading = false;
        this.joinTable = res.data.records;
        this.totalAward = Number(res.data.total);
      }).catch((res) => { });
    },
    //发放记录 为中奖记录的接口awardRecord
    distributionRecord() {
      this.loading = true;
      // awardRecNew(this.formList)
      awardRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.distributionTable = res.data.records;
          this.totalDistribution = Number(res.data.total);
        })
        .catch((res) => { });
    },
    //导出
    async exportTheData(type) {// tab-pane的name值，以前都是根据活动类型来，但现在一个活动可能有多种导出
      console.log(this.rowData.activityType);
      if (this.rowData.activityType == 5 || this.rowData.activityType == 6) {
        if (type == 333) {
          let param = {
            ...this.formList,
            memberNick: this.formList.memberNick ? this.formList.memberNick : '',
            inviteNick: this.formList.inviteNick ? this.formList.inviteNick : '',
            startTime: this.formList.startTime ? this.formList.startTime : '',
            endTime: this.formList.endTime ? this.formList.endTime : '',
            isValidInvited: this.formList.isValidInvited ? this.formList.isValidInvited : '',
          }
          const queryParams = Object.keys(param).map(key => `${encodeURIComponent(key)}=${param[key] ? encodeURIComponent(param[key]) : ''}`).join('&');
          let elem = document.createElement("a");
          elem.style.display = "none";
          let url = "/api/inviteAttentionPointActivity/exportPointInviteAttentionPrizeDetail?" + queryParams;
          elem.href = url;
          console.log(url)
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        } else {
          let param = this.formList.activityId;
          let elem = document.createElement("a");
          elem.style.display = "none";
          let url = "/api/inviteAttentionPointActivity/exportInviteAttentionPrizeRecords?activityId=" + encodeURI(param);
          elem.href = url;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        }
      } else if (
        this.rowData.activityType == 16 ||
        this.rowData.activityType == 17 ||
        this.rowData.activityType == 18 ||
        this.rowData.activityType == 19
      ) {
        let param = this.formList.activityId;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = "/api/PointActivityEffectDetails/exportPointActivityPrizeDetailForPurchase?activityId=" + encodeURI(param);
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      } else if (this.rowData.activityType == 25) {
        //Note入会打榜
        let param = `${this.formList.activityId}&startTime=${this.formList.startTime ? this.formList.startTime : ''}&endTime=${this.formList.endTime ? this.formList.endTime : ''}&nick=${this.formList.nick ? this.formList.nick : ''}&prizeType=${this.formList.prizeType ? this.formList.prizeType : ''}&status=${this.formList.status ? this.formList.status : ''}`;
        console.log(param);
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = "/api/joinAndRankActivity/exportRankList?id=" + encodeURI(param);
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      } else if (type == 13) {
        // 大转盘
        let param = `${this.formList.activityId}&size=${this.formList.size ? this.formList.size : ''}&current=${this.formList.current ? this.formList.current : ''}&startTime=${this.formList.startTime ? this.formList.startTime : ''}&endTime=${this.formList.endTime ? this.formList.endTime : ''}&memberNick=${this.formList.memberNick ? this.formList.memberNick : ''}&taskType=${this.formList.taskType ? this.formList.taskType : ''}`;
        console.log(param);
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = "/api/PointActivityEffectDetails/exportBigWheelPrizeDetail?activityId=" + encodeURI(param);
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      } else if (
        this.rowData.activityType == 26 ||
        this.rowData.activityType == 27
      ) {
        //幸运抽奖 0元入会导出接口
        let param = this.formList.activityId;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = "/api/PointActivityAnalyticController/exportParticipation?activityId=" + encodeURI(param);
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      } else if (this.rowData.activityType == 32) {
        if (type == 16) {
          let param = this.formList.activityId;
          let elem = document.createElement("a");
          elem.style.display = "none";
          let url = "/api/PointActivityEffectDetails/birthDay/export?activityId=" + encodeURI(param);
          elem.href = url;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        } else if (type == 17) {
          let param = this.formList.activityId;
          let elem = document.createElement("a");
          elem.style.display = "none";
          let url = "/api/PointActivityEffectDetails/exportPointActivityPrizeDetail?activityId=" + encodeURI(param);
          elem.href = url;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        }
      } else if (this.rowData.activityType == 34) {
        if (type == 18) {
          let param = `${this.formList.activityId}&size=${this.formList.size ? this.formList.size : ''}&current=${this.formList.current ? this.formList.current : ''}&startTime=${this.formList.startTime ? this.formList.startTime : ''}&endTime=${this.formList.endTime ? this.formList.endTime : ''}&memberNick=${this.formList.memberNick ? this.formList.memberNick : ''}&startPointTime=${this.formList.startPointTime ? this.formList.startPointTime : ''}&endPointTime=${this.formList.endPointTime ? this.formList.endPointTime : ''}&status=${this.formList.status ? this.formList.status : ''}&prizeType=${this.formList.prizeType ? this.formList.prizeType : ''}&stage=${this.formList.stage ? this.formList.stage : ''}`;
          if(this.formList.startRemarkTime){
            param += `&startRemarkTime=${this.formList.startRemarkTime}`
          }
          if(this.formList.endRemarkTime){
            param += `&endRemarkTime=${this.formList.endRemarkTime}`
          }
          let elem = document.createElement("a");
          elem.style.display = "none";
          let url = "/api/PointActivityEffectDetails/exportPointActivityPrizeDetailForPurchase?activityId=" + encodeURI(param);
          elem.href = url;
          console.log("url", url)
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        } else if (type == 19) {
          let param = `${this.formList.activityId}&size=${this.formList.size ? this.formList.size : ''}&current=${this.formList.current ? this.formList.current : ''}&startTime=${this.formList.startTime ? this.formList.startTime : ''}&endTime=${this.formList.endTime ? this.formList.endTime : ''}&memberNick=${this.formList.memberNick ? this.formList.memberNick : ''}`;
          let elem = document.createElement("a");
          elem.style.display = "none";
          let url = "/api/PointActivityEffectDetails/exportActivityRecordList?activityId=" + encodeURI(param);
          elem.href = url;
          console.log("url", url)
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        }
      } else if (this.rowData.activityType == 7) {
        let param = `${this.formList.activityId}&size=${this.formList.size ? this.formList.size : ''}&current=${this.formList.current ? this.formList.current : ''}&startTime=${this.formList.startTime ? this.formList.startTime : ''}&endTime=${this.formList.endTime ? this.formList.endTime : ''}`;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = "/api/PointActivityEffectDetails/exportMemberImproveRecords?activityId=" + encodeURI(param);
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      } else if (this.rowData.activityType == 35) {
        let param
        if (type == 19) {
          param = `${this.orderList.activityId}&size=${this.orderList.size}&current=${this.orderList.current}&source=0`
          if (this.orderList.memberNick) {
            param += `&memberNick=${this.orderList.memberNick}`
          }
          if (this.orderList.joinTimeStart) {
            param += `&joinTimeStart=${this.orderList.joinTimeStart}`
          }
          if (this.orderList.joinTimeEnd) {
            param += `&joinTimeEnd=${this.orderList.joinTimeEnd}`
          }
          if (this.orderList.isReceive || this.orderList.isReceive === 0) {
            param += `&isReceive=${this.orderList.isReceive}`
          }
        } else if (type == 20) {
          param = `${this.formList.activityId}&size=${this.formList.size}&current=${this.formList.current}&source=1`
          if (this.formList.memberNick) {
            param += `&memberNick=${this.formList.memberNick}`
          }
          if (this.formList.stage || this.formList.stage === 0) {
            param += `&taskIndex=${this.formList.stage}`
          }
          if (this.formList.prizeType || this.formList.prizeType === 0) {
            param += `&prizeType=${this.formList.prizeType}`
          }
          if (this.formList.joinTimeStart) {
            param += `&joinTimeStart=${this.formList.joinTimeStart}`
          }
          if (this.formList.joinTimeEnd) {
            param += `&joinTimeEnd=${this.formList.joinTimeEnd}`
          }
          if (this.formList.sendTimeStart) {
            param += `&sendTimeStart=${this.formList.sendTimeStart}`
          }
          if (this.formList.sendTimeEnd) {
            param += `&sendTimeEnd=${this.formList.sendTimeEnd}`
          }
          if (this.formList.status || this.formList.status === 0) {
            param += `&status=${this.formList.status}`
          }
        } else if (type == 21) {
          param = `${this.formList.activityId}&size=${this.formList.size}&current=${this.formList.current}&source=2`
          if (this.formList.memberNick) {
            param += `&memberNick=${this.formList.memberNick}`
          }
          if (this.formList.startDeliveryTime) {
            param += `&deliveryTimeStart=${this.formList.startDeliveryTime}`
          }
          if (this.formList.endDeliveryTime) {
            param += `&deliveryTimeEnd=${this.formList.endDeliveryTime}`
          }
          if (this.formList.startTime) {
            param += `&sendTimeStart=${this.formList.startTime}`
          }
          if (this.formList.endTime) {
            param += `&sendTimeEnd=${this.formList.endTime}`
          }
          if (this.formList.status || this.formList.status === 0) {
            param += `&deliveryStatus=${this.formList.status}`
          }
        }
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = "/api/order-rank/getJoinRecord/export?id=" + encodeURI(param);
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      } else if (this.rowData.activityType == 37) {
        if (this.activeName == "twentyEight") {
          //会员礼品-参与记录 
          const param = `${this.formList.activityId}&size=${this.formList.size ? this.formList.size : ''}&current=${this.formList.current ? this.formList.current : ''}`
          let elem = document.createElement("a");
          elem.style.display = "none";
          let url = "/api/memberUpgradeGift/export?activityId=" + encodeURI(param);
          elem.href = url;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        } else if (this.activeName == "twentyNine") {
          // 领取记录
          let param = `${this.formList.activityId}&size=${this.formList.size ? this.formList.size : ''}&current=${this.formList.current ? this.formList.current : ''}&startTime=${this.formList.startTime ? this.formList.startTime : ''}&endTime=${this.formList.endTime ? this.formList.endTime : ''}&memberNick=${this.formList.memberNick ? this.formList.memberNick : ''}&status=${this.formList.status ? this.formList.status : ''}&prizeType=${this.formList.prizeType ? this.formList.prizeType : ''}&endPointTime=${this.formList.endPointTime ? this.formList.endPointTime : ''}&startPointTime=${this.formList.startPointTime ? this.formList.startPointTime : ''}`;
          let elem = document.createElement("a");
          elem.style.display = "none";
          let url = "/api/PointActivityEffectDetails/exportPointActivityPrizeDetail?activityId=" + encodeURI(param);
          elem.href = url;
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        }

      } else {
        let param = this.formList.activityId;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = "/api/PointActivityEffectDetails/exportPointActivityPrizeDetail?activityId=" + encodeURI(param);
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    },
    //问卷统计
    qusetionData() {
      this.loading = true;
      getQueData(this.rowData.id).then((res) => {
        console.log("res问卷统计11", res.data)
        this.loading = false;
        this.queData = res.data
        this.isShowQue = true
        this.isShowData = true
      })
    },
    //查看问卷
    questionLook(index) {
      this.loading = true;
      console.log("打印index", index)
      getQueLook(this.rowData.id, index)
        .then((res) => {
          console.log("res查看问卷22", res.data)
          this.loading = false;
          this.queItem = res.data;
          this.isShowQue = true
          this.isShowLook = true
        })
        .catch((res) => { });
    },
    //关闭问卷弹窗
    closeQueLook() {
      this.isShowQue = false
      this.isShowData = false
      this.isShowLook = false
    },
    //实物奖品
    inKingRecord() {
      this.loading = true;
      console.log(this.formList);
      // 下单冲榜
      if (this.rowData.activityType == 35) {
        const query = {
          current: this.formList.current,
          size: this.formList.size,
          source: 2, //参与记录
          id: this.rowData.id
        }
        if (this.formList.memberNick) {
          query.memberNick = this.formList.memberNick
        }
        if (this.formList.startDeliveryTime) {
          query.deliveryTimeStart = this.formList.startDeliveryTime
        }
        if (this.formList.endDeliveryTime) {
          query.deliveryTimeEnd = this.formList.endDeliveryTime
        }
        if (this.formList.startTime) {
          query.sendTimeStart = this.formList.startTime
        }
        if (this.formList.endTime) {
          query.sendTimeEnd = this.formList.endTime
        }
        if (this.formList.status || this.formList.status === 0) {
          query.deliveryStatus = this.formList.status
        }
        getJoinRecord(query)
          .then((res) => {
            this.loading = false;
            this.inkindTable = res.data.records;
            this.totalInkind = Number(res.data.total);
          })
      } else {
        console.log(this.formList, '656546454645654')
        inKindList(this.formList)
          .then((res) => {
            this.loading = false;
            this.totalInkind = Number(res.data.total);
            this.inkindTable = res.data.records;
          })
          .catch((res) => { });
      }
    },
    //资料明细
    improveRecord() {
      this.loading = true;
      if (!this.formList.startTime && !this.formList.endTime) {
        this.formList.startTime = "2010-01-01 00:00:00";
        this.formList.endTime = "2030-01-01 23:59:59";
      }
      this.formList.sex = this.formList.sex || 0
      improveList(this.formList)
        .then((res) => {
          this.loading = false;
          this.userInfoTable = res.data.records;
          this.totalUserInfo = Number(res.data.total);
        })
        .catch((res) => { });
    },
    //标记状态
    markIss(row, e) {
      let params = {
        id: row.id || row.recordId
      }
      if (e == 'win') {
        params.status = 2
      }
      signIssuance(params)
        .then((res) => {
          if (res && res.code == 1) {
            this.winningRecord();
            this.getParticipation();
            this.getPrizeReceiveRecord();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => { });
    },
    //下单冲榜-标记状态
    markIss2(row) {
      markingPrizeStatus(row.recordId)
        .then((res) => {
          if (res && res.code == 1) {
            this.getPrizeReceiveRecord2()
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => { });
    },
    // 抽奖机会赠送
    commentDraw() {
      this.loading = true;
      commentDraw(this.formList)
        .then((res) => {
          this.loading = false;
          this.CommentList = res.data.records;
          this.totalComment = Number(res.data.total);
        })
        .catch((res) => { });
    },
    // 拼券明细
    CoupondDtails() {
      this.loading = true;
      getSplitCouponlist(this.formList)
        .then((res) => {
          this.loading = false;
          this.couponDetailsList = res.data.records;
          this.totalCoupon = Number(res.data.total);
        })
        .catch((res) => { });
    },
    // 优惠券统计
    CouponStatistics() {
      this.loading = true;
      getStatisticsCouponlist(this.formList)
        .then((res) => {
          this.loading = false;
          this.CouponStatisticsList = res.data.records.map((item, index) => {
            let obj = item;
            obj.id = index + "@10";
            let num = index++;
            if (obj.data.length != 0) {
              obj.data.forEach((ele, i) => {
                ele.id = num + new Date();
              });
            }
            return obj;
          });
          this.totalCouponstatistics = Number(res.data.total);
        })
        .catch((res) => { });
    },
    // 团队详情
    TeamDetails() {
      this.loading = true;
      CouponDetail(this.formList)
        .then((res) => {
          this.loading = false;
          this.TeamDetailsList = res.data.records;
          this.totalTeam = Number(res.data.total);
        })
        .catch((res) => { });
    },
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.queryTotal();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.queryTotal();
    },
    handleSizeSignIn(val) {
      this.formList.size = val;
      this.checkRecord();
    },
    handleCurrentSignIn(val) {
      this.formList.current = val;
      this.checkRecord();
    },
    // 参与记录
    handleSizeParticipat(val) {
      this.formList.size = val;
      this.getParticipation();
    },
    handleCurrentParticipat(val) {
      this.formList.current = val;
      this.getParticipation();
    },
    //参与记录问卷调查
    handleSizeParticipat2(val) {
      this.formList.size = val;
      this.getParticipation2();
    },
    handleCurrentParticipat2(val) {
      this.formList.current = val;
      this.getParticipation2();
    },
    //参与记录满额有礼
    handleSizeParticipat3(val) {
      this.formList.size = val;
      this.getParticipation3();
    },
    handleCurrentParticipat3(val) {
      if (this.rowData.activityType == 35) {
        this.orderList.current = val
        this.getParticipation4()
      } else {
        this.formList.current = val;
        this.getParticipation3();
      }
    },
    handleSizeAward(val) {
      this.formList.size = val;
      this.winningRecord();
    },

    handleSizeAward29(val) {
      this.formList.size = val;
      this.getParticipation29();
    },
    handleSizeAwardOne(val) {
      this.formList.size = val;
      this.distributionRecord();
    },
    // 邀请关注明细分页
    handleSizeAwardTow(val) {
      this.inviteForm.size = val;
      pointInviteAttentionPrizeDetail(this.inviteForm).then((res) => {
        this.inviteInfoList = res.data.records
        this.inviteTotal = res.data.total
        console.log(res);
      })
    },
    handleCurrentAward(val) {
      this.formList.current = val;
      this.winningRecord();
    },
    handleCurrentAward29(val) {
      this.formList.current = val;
      this.getParticipation29();
    },
    // 填写记录分页
    handleSizeWrite(val) {
      this.formList.size = val;
      this.getWriteRecord();
    },
    handleCurrentWrite(val) {
      this.formList.current = val;
      this.getWriteRecord();
    },
    // 奖品领取记录分页
    handleSizePrizeReceive(val) {
      this.formList.size = val;
      this.getPrizeReceiveRecord();
    },
    handleCurrentPrizeReceive(val) {
      this.formList.current = val;
      this.getPrizeReceiveRecord();
    },
    // 兑换明细
    handleExchangeList(val) {
      this.formList.size = val;
      this.searchExchangeList();
    },
    handleCurrentExchangeList(val) {
      this.formList.current = val;
      this.searchExchangeList();
    },
    //打榜名单
    handleSizeRank(val) {
      this.formList.size = val;
      this.rankListOne();
    },
    handleCurrentRank(val) {
      this.formList.current = val;
      this.rankListOne();
    },
    handleCurrentAwardOne(val) {
      this.inviteForm.current = val;
      this.distributionRecord();
    },
    handleCurrentAwardTow(val) {
      this.inviteForm.current = val;
      pointInviteAttentionPrizeDetail(this.inviteForm).then((res) => {
        this.inviteInfoList = res.data.records
        this.inviteTotal = res.data.total
      })
    },
    handleSizeInkind(val) {
      this.formList.size = val;
      this.inKingRecord();
    },
    handleCurrentInkind(val) {
      this.formList.current = val;
      this.inKingRecord();
    },
    handleSizeInkind30(val) {
      this.formList.size = val;
      this.getParticipation30();
    },
    handleCurrentInkind30(val) {
      this.formList.current = val;
      this.getParticipation30();
    },
    handleSizeUserInfo(val) {
      this.formList.size = val;
      this.improveRecord();
    },
    handleCurrentUserInfo(val) {
      this.formList.current = val;
      this.improveRecord();
    },
    // 抽奖机会赠送
    handleSizeComment(val) {
      this.formList.size = val;
      this.commentDraw();
    },
    handleCurrentComment(val) {
      this.formList.current = val;
      this.commentDraw();
    },
    // 拼券明细
    handleSizeCoupond(val) {
      this.formList.size = val;
      this.CoupondDtails();
    },
    handleCurrentCoupond(val) {
      this.formList.current = val;
      this.CoupondDtails();
    },
    // 优惠券统计
    handleSizeCouponStatistics(val) {
      this.formList.size = val;
      this.CouponStatistics();
    },
    handleCurrentCouponStatistics(val) {
      this.formList.current = val;
      this.CouponStatistics();
    },
    // 团队详情
    handleSizeTeam(val) {
      this.formList.size = val;
      this.TeamDetails();
    },
    handleCurrentTeam(val) {
      this.formList.current = val;
      this.TeamDetails();
    },
    // 赠送记录
    handleSizeGiftrecord(val) {
      this.formList.size = val;
      this.getGameTaskRecord();
    },
    handleCurrentGiftrecord(val) {
      this.formList.current = val;
      this.getGameTaskRecord();
    },
    // 预约记录
    handleSizeExchange2(val) {
      this.formList.size = val;
      this.getappointment()
    },
    handleCurrentExchange2(val) {
      this.formList.current = val;
      this.getappointment()
    },
    //签到查询
    searchForm(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.checkRecord();
    },
    //参与记录查询
    searchParticipationForm(val) {
      console.log("查询", val);
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.startScore = val.startScore;
      this.formList.endScore = val.endScore;
      this.formList.isPass = val.isPass;
      this.formList.isDraw = val.isDraw;
      this.formList.isWin = val.isWin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      if (this.rowData.activityType == 26) {
        this.formList.isWriteAddress = val.isWriteAddress;
      }
      this.getParticipation();
    },
    //参与记录查询
    searchParticipationForm2(val) {
      console.log("查询2", val);
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.startScore = val.startScore;
      this.formList.endScore = val.endScore;
      this.formList.isPass = val.isPass;
      this.formList.isDraw = val.isDraw;
      this.formList.isWin = val.isWin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.isWriteAddress = val.isWriteAddress;
      this.getParticipation2();
    },
    // 会员升级礼
    searchParticipationForm28(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick || '';
      this.formList.createStartTime = val.createStartTime || '';
      this.formList.createEndTime = val.createEndTime || '';
      this.formList.latestJoinStartTime = val.latestJoinStartTime || '';
      this.formList.latestJoinEndTime = val.latestJoinEndTime || '';
      this.formList.isUpgrades = val.isUpgrades
      this.formList.isWin = val.isWin
      this.getParticipation28();
    },
    searchAward29(val) {
      console.log("🚀 ~ searchAward29 ~ val:", val)
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick || '';
      this.formList.prizeType = val.prizeType
      this.formList.startTime = val.startTime || '';
      this.formList.endTime = val.endTime || '';
      this.formList.startPointTime = val.startPointTime || '';
      this.formList.endPointTime = val.endPointTime || '';
      this.formList.status = val.status
      this.getParticipation29();
    },
    handleSizeParticipat28(val) {
      this.formList.size = val;
      this.getParticipation28();
    },
    handleCurrentParticipat28(val) {
      this.formList.current = val;
      this.getParticipation28();
    },
    //参与记录查询
    searchParticipationForm3(val) {
      console.log("查询", val);
      if (this.rowData.activityType == 35) {
        this.orderList.current = 1;
        this.orderList.size = 10;
        this.orderList.memberNick = val.memberNick;
        this.orderList.joinTimeStart = val.joinTimeStart;
        this.orderList.joinTimeEnd = val.joinTimeEnd;
        this.orderList.isReceive = val.isReceive;
        this.getParticipation4();
      } else {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.memberNick = val.memberNick;
        this.formList.startTime = val.startTime;
        this.formList.endTime = val.endTime;
        this.getParticipation3();
      }
    },
    searchAward(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.distributionRecord();
    },
    //填写记录查询
    searchFormWrite(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.isReceive = val.isReceive;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.startBirthTime = val.startBirthTime;
      this.formList.endBirthTime = val.endBirthTime;
      this.formList.startLastPrizeTime = val.startLastPrizeTime
      this.formList.endLastPrizeTime = val.endLastPrizeTime
      this.getWriteRecord();
    },
    //奖品领取记录查询
    searchPrizeReceive(val) {
      console.log(val, 'form')
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.isReceive = val.isReceive;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startBirthTime = val.startBirthTime;
      this.formList.endBirthTime = val.endBirthTime;
      this.formList.startRemarkTime = val.startRemarkTime
      this.formList.endRemarkTime = val.endRemarkTime
      if (this.rowData.activityType == 34) {
        this.formList.stage = val.stage;
        this.formList.startPointTime = val.startPointTime;
        this.formList.endPointTime = val.endPointTime;
      }
      if (this.rowData.activityType == 35) {
        this.formList.stage = val.stage;
        this.formList.joinTimeStart = val.joinTimeStart;
        this.formList.joinTimeEnd = val.joinTimeEnd;
        this.formList.sendTimeStart = val.sendTimeStart;
        this.formList.sendTimeEnd = val.sendTimeEnd;
      }
      if (this.rowData.activityType == 35) {
        this.getPrizeReceiveRecord2()
      } else {
        this.getPrizeReceiveRecord();
      }
    },
    //发放记录
    searchAwardOne(val) {
      console.log('val------>', val)
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.unlockOrderId = val.unlockOrderId;
      this.formList.orderState = val.orderState;
      this.formList.isFillAddress = val.isFillAddress
      this.formList.joinTimeStart = val.joinTimeStart;
      this.formList.joinTimeEnd = val.joinTimeEnd;
      if (this.rowData.activityType == 1 || this.rowData.activityType == 8 || this.rowData.activityType == 19 || this.rowData.activityType == 16 || this.rowData.activityType == 17 || this.rowData.activityType == 18 || this.rowData.activityType == 32) {
        this.formList.startRemarkTime = val.startRemarkTime;
        this.formList.endRemarkTime = val.endRemarkTime;
      }
      this.winningRecord();
    },
    // 积分兑换
    searchExchange(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.prizeName = val.prizeName;
      this.formList.id = val.activityId
      this.searchExchangeList()
    },
    //入会打榜
    searchAwardOneJoin(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.nick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.id = val.activityId
      this.rankListOne();
    },
    // 预约记录
    searchFormThir2(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.memberNick = val.memberNick;
      this.formList.isWin = val.isWin;
      this.getappointment();
    },
    searchInkind(val) {
      console.log('val------>', val)
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      if ([1, 8, 16, 17, 18, 19, 26, 32, 34].includes(this.rowData.activityType)) {
        this.formList.startRemarkTime = val.startRemarkTime;
        this.formList.endRemarkTime = val.endRemarkTime;
      }
      if (this.rowData.activityType == 31 || this.rowData.activityType == 34 || this.rowData.activityType == 35) {
        this.formList.status = val.status;
        this.formList.startDeliveryTime = val.startDeliveryTime;
        this.formList.endDeliveryTime = val.endDeliveryTime;
      }
      this.inKingRecord();
    },
    search30(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.startDeliveryTime = val.startDeliveryTime;
      this.formList.endDeliveryTime = val.endDeliveryTime;
      this.formList.status = val.status;
      this.getParticipation30()
    },
    searchUserInfo(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      let birthDayStart = ""
      let birthDayEnd = ""
      if(val.birthDayStart) {
        let start = val.birthDayStart;
        // 1. 提取月份和日期
        let monthStart = start.split('月')[0]; // 获取月份数字 (7)
        birthDayStart = dayjs()
          .month(monthStart-1)
          .startOf('month')
          .format('MM-DD');
      }
      if(val.birthDayEnd) {
        let end = val.birthDayEnd;
        let monthEnd = end.split('月')[0]; // 获取月份数字 (7)
        birthDayEnd = dayjs()
          .month(monthEnd-1)
          .endOf('month')
          .format('MM-DD');
      }
      this.formList.birthDayStart = birthDayStart;
      this.formList.birthDayEnd = birthDayEnd;
      this.formList.sex = val.sex;
      this.formList.jobs = val.jobs;
      this.improveRecord();
    },
    searchComment(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.orderId = val.orderId;
      this.formList.nickName = val.nickName;
      this.formList.filterType = val.filterType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.commentDraw();
    },
    searchCoupon(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.CoupondDtails();
    },
    searchSplit(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.startTime = val.startTime ? val.startTime + " 00:00:00" : "";
      this.formList.endTime = val.endTime ? val.endTime + " 23:59:59" : "";
      this.CouponStatistics();
    },
    searchGroup(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.startTime = val.startTime ? val.startTime + " 00:00:00" : "";
      this.formList.endTime = val.endTime ? val.endTime + " 23:59:59" : "";
      this.TeamDetails();
    },
    // 赠送记录
    searchGiftrecord(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.taskType = val.taskType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.getGameTaskRecord();
    },
    // 邀请记录
    searchInvitation(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick
      this.formList.startTime = val.startTime
      this.formList.endTime = val.endTime
      this.formList.isValidInvited = val.isValidInvited
      this.formList.inviteNick = val.inviteNick
      this.getInvitation();
    },
    getInvitation() {
      this.loading = true;
      pointInviteAttentionPrizeDetail(this.formList)
        .then((res) => {
          this.loading = false;
          this.InvitationList = res.data.records;
          this.totalInvitation = Number(res.data.total);
        })
    },
    // 点击解密  name: 修改的字段名   objdata：数组的名称, params:接口的参数  item：点击的对象    index：数组传下标值
    handleDecrypt(name, objdata, item, index, type = "simple") {
      let content = "";
      // 资料明细 userInfoTable  实物奖品 inkindTable 0元使用的中奖记录 awardTable
      if (objdata == "userInfoTable") {
        content = "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "inkindTable") {
        content = "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "awardTable") {
        content = "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      }
      let params = {
        type: type,
        venderId: this.$store.state.loginUserInfo.sellerId,
        isEncrypt: false,
        content: item[`${content}`],
      };

      this.$decrypt.decrypt(params).then((res) => {
        console.log(res, 465132);
        this[`${objdata}`][index][`${name}`] = res + "";
      });
    },
    getWheelPrize() {
      this.loading = true;
      this.WheelPrizeList = []
      getWheelPrizeDetail(this.formList).then(res => {
        this.loading = false;
        this.WheelPrizeList = res.data.records;
        this.totalWheelrecord = Number(res.data.total);
      }).catch((res) => { });
    },
    searchWheelPrize(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.taskType = val.taskType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.getWheelPrize()
    },
    handleSizeWheelrecord(val) {
      this.formList.size = val;
      this.getWheelPrize()
    },
    handleCurrentWheelrecord(val) {
      this.formList.current = val;
      this.getWheelPrize()
    },
    handleSizeInvitation(val) {
      this.formList.size = val;
      this.getInvitation()
    },
    handleCurrentInvitationd(val) {
      this.formList.current = val;
      this.getInvitation()
    },
    // 监听录入快递单号按钮
    handleEnterCoutierNum(row) {
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.$forceUpdate();
      // 打开弹窗
      this.enterCoutierNumShow = true;
    },
    // 置空录入快递单号输入框并关闭弹窗
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.enterCoutierNumShow = false;
      this.sendOutGoodsShow = false;
    },
    // 录入快递单号提交
    enterCoutierSubmit() {
      let params = {
        id: this.enterCoutierRowData.id,
        billCode: this.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      }
      // console.log("enterCoutierRowData", this.enterCoutierRowData);
      // console.log("录入快递单信息参数", params);
      markingSendStatusLockRight(params).then((res) => {
        console.log("markingSendStatusLockRight", res);
        if (res.code == 1) {
          this.inKingRecord();
          // 标记发货
          // this.markIss(this.enterCoutierRowData).then(()=>{
          // 置空录入快递单号输入框
          this.blankEnterCoutierNum();
          // });
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message.error("录入快递单号失败");
      })


    },
    clearInput(e) {
      let key = e.key;
      if (key === 'e' || key === 'E' || key === '+' || key === '-') {
        e.returnValue = false;
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.marker-btn {
  width: auto;
  padding: 0px !important;
}

.imgurl {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin-right: 7px;

  img {
    width: 80px;
  }
}

.referenceButton {
  cursor: pointer;

  // color: #2670FB;
  &:hover {
    color: #2670fb;
  }
}

.referencePopover {
  display: flex;

  span {
    display: block;
    margin-right: 20px;
  }

  span:last-child {
    margin-right: 0px;
  }
}

.decryptHover {
  display: none;
  margin-left: 4px;
  background: none;
}

.decrypt {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}

.decrypt:hover .decryptHover {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background: none;
}

.question_iconOne {
  width: 13px;
  height: 13px;
  display: inline-block;
  line-height: 13px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 4px;
  color: #ccc;
}

.titClass {
  padding: 36px 24px;
  // margin: 35px;
  margin-bottom: 25px;
  background: #fafafa;
  opacity: 1;
  display: flex;
  align-items: center;
  line-height: 22px;
  position: relative;

  .titClassOne {
    margin: 0px 100px 0px 30px;
  }

  .down {
    margin-right: 30px;
  }

  .borderU {
    position: absolute;
    width: 1px;
    height: 110px;
    background: #f3f3f3;
    left: 122px;
  }
}

.acitvityAll {
  background: #fff;

  .headReturn {
    box-sizing: border-box;
    // padding-left: 30px;
    width: 100%;
    // height: 50px;
    // line-height: 49px;
    // border-bottom: 1px solid #f3f3f3;
  }

  .formSty {
    margin: 35px;

    .question_icon {
      width: 15px;
      height: 15px;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #ccc;
      font-size: 14px !important;
      font-weight: normal !important;
      margin-left: 4px;
    }

    .y1,
    .y2,
    .y3,
    .y4 {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 5px;
    }

    .y1 {
      background-color: #cccccc;
    }

    .y2 {
      background-color: #7f85e9;
    }

    .y3 {
      background-color: #2670fb;
    }

    .y4 {
      background-color: #49c568;
    }

    .section-right-content-box {

      // min-width: 1000px;
      // border-bottom: 6px;
      // padding: 15px 28px 30px 28px;
      // background: rgba(255, 255, 255, 1);
      // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      // opacity: 1;
      // -webkit-box-sizing: border-box;
      // -moz-box-sizing: border-box;
      // box-sizing: border-box;
      // margin: 0 20px 20px 20px;
      .tabList {
        display: flex;
        box-sizing: border-box;
        height: 36px;
        line-height: 35px;
        // margin-top: 20px;
        color: #666;
        font-size: 14px;
        margin: 20px 0;

        span {
          margin-right: 3px;
          width: 106px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          vertical-align: middle;
          transform: perspective(1px) translateZ(0);
          box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          border-radius: 2px 2px 0px 0px;
          border: 1px solid #dddddd;
          text-align: center;
        }

        .active {
          position: relative;
          transition: all 0.2s;
          color: #2670fb;
          border-bottom: none;

          &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            top: 0;
            height: 2px;
            background: #2670fb;
            border-radius: 6px 6px 0px 0px;
          }
        }

        i {
          flex: 1;
          border-bottom: 1px solid #dddddd;
          margin-left: -3px;
        }
      }

      .b1 {
        width: 98px;
        height: 32px;
        color: #fff;
        border: 1px solid #2670fb;
        background-color: #2670fb;

        &:hover {
          opacity: 0.8;
        }
      }

      .b2 {
        width: 98px;
        height: 32px;
        color: #666666;
        border: 1px solid #dddddd;
        background-color: #fff;

        &:hover {
          color: #2670fb;
          border: 1px solid #2670fb;
          background: rgba(38, 112, 251, 0.1);
          // background-color: #fff4f4;
        }
      }

      .background {
        height: 32px;
        background: rgba(250, 250, 250, 1);
        opacity: 1;
        line-height: 32px;
        padding-left: 12px;

        .title {
          display: inline-block;
          width: 2px;
          height: 14px;
          background: #2670fb;
          opacity: 1;
          border-radius: 3px;
          vertical-align: middle;
        }

        .tips {
          width: 56px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
          vertical-align: middle;
        }
      }

      .overview1 {
        padding: 26px 30px 22px 30px;
        width: 20%;
        height: 100px;
        border-right: 1px solid #f3f3f3;
        opacity: 1;
        margin: 20px 0px;

        .fontClass {
          width: 102px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: rgba(102, 102, 102, 1);
          opacity: 1;
        }

        .question_icon {
          width: 14px;
          height: 14px;
          color: #cccccc;
          display: inline-block;
          line-height: 12px;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #cccccc;
          font-size: 12px;
          font-weight: normal;
        }

        .num {
          width: 65px;
          height: 29px;
          font-size: 24px;
          font-family: DIN;
          font-weight: bold;
          line-height: 29px;
          color: #2670fb;
          opacity: 1;
          margin-top: 14px;
          margin-bottom: 30px;
        }
      }

      .chart {
        // flex: 1;
        height: 380px;
        min-width: 1100px;
      }
    }
  }
}

/* 导出数据模态框 */
.sendHug {
  width: 345px;
  height: 30px;
  background: rgba(255, 118, 0, 0.1);
  margin-left: 10px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 118, 0, 1);
}

.hug-send {
  overflow: hidden;
  margin-top: 20px;
  height: 32px;
  display: flex;
  align-items: center;

  .send-left {
    float: left;
    height: 32px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 20px;
    color: rgba(102, 102, 102, 1);
    margin-left: 50px;
  }

  .send-right {
    float: left;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 21px;
    color: rgba(51, 51, 51, 1);
    width: 220px;
    height: 100%;

    .send-ipnut {
      display: flex;
      width: 100%;
      height: 28px;
      line-height: 28px;
      border: 1px solid rgba(51, 51, 51, 0.2);
      border-radius: 4px;
      text-indent: 6px;
    }
  }

  .send-right2 {
    height: 32px;
    // border-bottom: 2px solid rgba(245, 245, 245, 1);
  }

  .codeBtn {
    border: none;
    width: 110px;
    display: inline-block;
    line-height: 26px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    color: rgba(51, 51, 51, 1);
    outline-style: none;
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-radius: 4px;
    padding-left: 6px;
  }

  .getNumber {
    display: inline-block;
    width: 100px;
    border: none;
    background: none;
    outline-style: none;
    color: #2670fb;
    line-height: 26px;
    border: 1px solid #2670fb;
    margin-left: 10px;
    border-radius: 4px;
    cursor: pointer;
  }

  .getNumber-Disabled {
    color: rgba(51, 51, 51, 0.2) !important;
    border-color: rgba(51, 51, 51, 0.2) !important;
    cursor: no-drop;
  }

  .msg {
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 14px;
    color: #2670fb;
    text-align: center;
  }
}

.dialogExprot-btn {
  width: 380px;
  display: inline-flex;
  justify-content: center;

  >span {
    display: inline-flex;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-right: 8px;
    cursor: pointer;
  }

  >span:nth-of-type(1) {
    background: #2670fb;
    color: #fff;
    border-color: #2670fb;
  }
}

.inviteNum {
  // text-align: center;
  color: #2670fb;
  cursor: pointer;
  text-decoration: underline;
}

.batchall_button {
  border: 1px solid #2670fb;
  color: #2670fb;
  transition: all 0.2s;

  &:hover {
    background-color: #2670fb;
    color: #fff;
  }
}

.info {
  display: flex;
  align-items: center;
  margin-top: 8px;

  .img-parent {
    margin-left: 4px;
    margin-right: 4px;
    height: 50px;
    position: relative;
    display: inline-block;

    &:hover {
      cursor: pointer;

      .mask {
        opacity: 1;
      }
    }

    .mask {
      position: absolute;
      opacity: 0;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      transition: all 0.3s;

      i {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
      }
    }

    .info-img {
      width: 100%;
      height: 50px;
    }
  }
}

.bigImg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 99;

  img {
    height: 80%;
  }

  i {
    cursor: pointer;
    margin-top: 12px;
    font-size: 25px;
    color: #fff;
  }
}

.enter-btn {
  width: 0px;
  padding: 0px !important;
}

.enter_coutier_num_dialog_floor {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
